var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
(function(global, factory) {
  typeof exports === "object" && typeof module !== "undefined" ? factory(exports, require("vue"), require("@variantjs/core"), require("@popperjs/core")) : typeof define === "function" && define.amd ? define(["exports", "vue", "@variantjs/core", "@popperjs/core"], factory) : (global = typeof globalThis !== "undefined" ? globalThis : global || self, factory(global.VariantJS = {}, global.Vue, global.core, global.core$1));
})(this, function(exports2, vue, core, core$1) {
  "use strict";
  class Emitter {
    constructor() {
      __publicField(this, "events", {});
    }
    on(name, callback) {
      if (this.events[name] === void 0) {
        this.events[name] = [callback];
      } else {
        this.events[name].push(callback);
      }
    }
    once(name, callback) {
      const listener = (...args) => {
        callback(...args);
        this.off(name, listener);
      };
      return this.on(name, listener);
    }
    emit(name, ...args) {
      const events = this.events[name];
      if (events === void 0) {
        return;
      }
      events.forEach((callback) => {
        callback(...args);
      });
    }
    off(name, callback) {
      const events = this.events[name];
      if (events === void 0) {
        return;
      }
      const index = events.findIndex((c) => c === callback);
      if (index < 0) {
        return;
      }
      events.splice(index, 1);
      this.events[name] = events;
    }
  }
  const getVariantProps = () => ({
    classes: {
      type: [String, Array, Object],
      default: void 0
    },
    fixedClasses: {
      type: [String, Array, Object],
      default: void 0
    },
    variants: {
      type: Object,
      default: void 0
    },
    variant: {
      type: String,
      default: void 0
    }
  });
  const getVariantPropsWithClassesList = () => ({
    classes: {
      type: [String, Array, Object],
      default: void 0
    },
    fixedClasses: {
      type: [String, Array, Object],
      default: void 0
    },
    variants: {
      type: Object,
      default: void 0
    },
    variant: {
      type: String,
      default: void 0
    }
  });
  const sameWidthModifier = {
    name: "sameWidth",
    enabled: true,
    phase: "beforeWrite",
    requires: ["computeStyles"],
    fn: (options) => {
      const { state } = options;
      state.styles.popper.width = `${state.rects.reference.width}px`;
    },
    effect: (options) => {
      const { state } = options;
      const reference = state.elements.reference;
      state.elements.popper.style.width = `${reference.offsetWidth}px`;
    }
  };
  const icons = {};
  const svgToVueComponent = (el, deep = 0) => {
    let iconAsString = null;
    if (deep === 0) {
      iconAsString = typeof el === "string" ? el : el.outerHTML;
      if (icons[iconAsString]) {
        return icons[iconAsString];
      }
    }
    let elToConvert = el;
    if (typeof elToConvert === "string") {
      const div = document.createElement("div");
      div.innerHTML = elToConvert;
      elToConvert = div.firstElementChild;
    }
    if (elToConvert === null) {
      return vue.h("span");
    }
    const attributes = Array.from(elToConvert.attributes);
    const children = Array.from(elToConvert.children);
    const attrs = {};
    attributes.filter((attribute) => !attribute.name.startsWith("on")).forEach((attribute) => {
      attrs[attribute.name] = attribute.value;
    });
    const component = vue.h(elToConvert.tagName, attrs, children.map((child) => svgToVueComponent(child, deep + 1)));
    if (deep === 0 && iconAsString !== null) {
      icons[iconAsString] = component;
    }
    return component;
  };
  const extractDefinedProps = (vm) => {
    const validProps = Object.keys(vm.props);
    const definedProps = Object.keys(vm.vnode.props || {}).map((propName) => vue.camelize(propName)).filter((propName) => validProps.includes(propName) && propName !== "modelValue");
    return definedProps;
  };
  function useAttributes(configuration) {
    const vm = vue.getCurrentInstance();
    const computedAttributes = vue.computed(() => {
      const availableProps = Object.keys(vm.props);
      return core.pick(configuration, (value, key) => core.isPrimitive(value) && !availableProps.includes(String(key)));
    });
    const attributes = vue.reactive(computedAttributes.value);
    vue.watch(computedAttributes, (newValue) => {
      Object.keys(newValue).forEach((key) => {
        if (!core.isEqual(attributes[key], newValue[key])) {
          attributes[key] = newValue[key];
        }
      });
    });
    return attributes;
  }
  function useConfigurationParts() {
    const vm = vue.getCurrentInstance();
    const variantGlobalConfiguration = vue.inject("configuration", {});
    const componentGlobalConfiguration = core.get(variantGlobalConfiguration, vm == null ? void 0 : vm.type.name, {});
    const propsValues = vue.computed(() => {
      const values = {};
      extractDefinedProps(vm).forEach((attributeName) => {
        const normalizedAttribute = vue.camelize(attributeName);
        values[normalizedAttribute] = vm.props[normalizedAttribute];
      });
      return values;
    });
    return {
      componentGlobalConfiguration,
      propsValues
    };
  }
  function useConfiguration(defaultConfiguration) {
    const vm = vue.getCurrentInstance();
    const { propsValues, componentGlobalConfiguration } = useConfigurationParts();
    const computedConfiguration = vue.computed(() => {
      const props = __spreadValues({}, vm.props);
      delete props.modelValue;
      return __spreadValues(__spreadValues({}, props), core.parseVariant(propsValues.value, componentGlobalConfiguration, defaultConfiguration));
    });
    const configuration = vue.reactive(computedConfiguration.value);
    vue.watch(computedConfiguration, (newValue) => {
      Object.keys(newValue).forEach((key) => {
        configuration[key] = newValue[key];
      });
    });
    const attributes = useAttributes(configuration);
    return {
      configuration,
      attributes
    };
  }
  function useConfigurationWithClassesList(defaultConfiguration, classesListKeys) {
    const vm = vue.getCurrentInstance();
    const { propsValues, componentGlobalConfiguration } = useConfigurationParts();
    const computedConfiguration = vue.computed(() => __spreadValues(__spreadValues({}, vm.props), core.parseVariantWithClassesList(propsValues.value, classesListKeys, componentGlobalConfiguration, defaultConfiguration)));
    const configuration = vue.reactive(computedConfiguration.value);
    vue.watch(computedConfiguration, (newValue) => {
      Object.keys(newValue).forEach((key) => {
        configuration[key] = newValue[key];
      });
    });
    const attributes = useAttributes(configuration);
    return {
      configuration,
      attributes
    };
  }
  function useVModel(props, key) {
    const vm = vue.getCurrentInstance();
    const localValue = vue.ref(props[key]);
    vue.watch(localValue, (value) => {
      vm == null ? void 0 : vm.emit(`update:${key}`, value);
    });
    vue.watch(() => props[key], (value) => {
      localValue.value = value;
    });
    return localValue;
  }
  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    } else {
      return Array.from(arr);
    }
  }
  var hasPassiveEvents = false;
  if (typeof window !== "undefined") {
    var passiveTestOptions = {
      get passive() {
        hasPassiveEvents = true;
        return void 0;
      }
    };
    window.addEventListener("testPassive", null, passiveTestOptions);
    window.removeEventListener("testPassive", null, passiveTestOptions);
  }
  var isIosDevice = typeof window !== "undefined" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
  var locks = [];
  var documentListenerAdded = false;
  var initialClientY = -1;
  var previousBodyOverflowSetting = void 0;
  var previousBodyPosition = void 0;
  var previousBodyPaddingRight = void 0;
  var allowTouchMove = function allowTouchMove2(el) {
    return locks.some(function(lock) {
      if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
        return true;
      }
      return false;
    });
  };
  var preventDefault = function preventDefault2(rawEvent) {
    var e = rawEvent || window.event;
    if (allowTouchMove(e.target)) {
      return true;
    }
    if (e.touches.length > 1)
      return true;
    if (e.preventDefault)
      e.preventDefault();
    return false;
  };
  var setOverflowHidden = function setOverflowHidden2(options) {
    if (previousBodyPaddingRight === void 0) {
      var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
      var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
      if (_reserveScrollBarGap && scrollBarGap > 0) {
        var computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"), 10);
        previousBodyPaddingRight = document.body.style.paddingRight;
        document.body.style.paddingRight = computedBodyPaddingRight + scrollBarGap + "px";
      }
    }
    if (previousBodyOverflowSetting === void 0) {
      previousBodyOverflowSetting = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    }
  };
  var restoreOverflowSetting = function restoreOverflowSetting2() {
    if (previousBodyPaddingRight !== void 0) {
      document.body.style.paddingRight = previousBodyPaddingRight;
      previousBodyPaddingRight = void 0;
    }
    if (previousBodyOverflowSetting !== void 0) {
      document.body.style.overflow = previousBodyOverflowSetting;
      previousBodyOverflowSetting = void 0;
    }
  };
  var setPositionFixed = function setPositionFixed2() {
    return window.requestAnimationFrame(function() {
      if (previousBodyPosition === void 0) {
        previousBodyPosition = {
          position: document.body.style.position,
          top: document.body.style.top,
          left: document.body.style.left
        };
        var _window = window, scrollY = _window.scrollY, scrollX = _window.scrollX, innerHeight = _window.innerHeight;
        document.body.style.position = "fixed";
        document.body.style.top = -scrollY;
        document.body.style.left = -scrollX;
        setTimeout(function() {
          return window.requestAnimationFrame(function() {
            var bottomBarHeight = innerHeight - window.innerHeight;
            if (bottomBarHeight && scrollY >= innerHeight) {
              document.body.style.top = -(scrollY + bottomBarHeight);
            }
          });
        }, 300);
      }
    });
  };
  var restorePositionSetting = function restorePositionSetting2() {
    if (previousBodyPosition !== void 0) {
      var y = -parseInt(document.body.style.top, 10);
      var x = -parseInt(document.body.style.left, 10);
      document.body.style.position = previousBodyPosition.position;
      document.body.style.top = previousBodyPosition.top;
      document.body.style.left = previousBodyPosition.left;
      window.scrollTo(x, y);
      previousBodyPosition = void 0;
    }
  };
  var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled2(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
  };
  var handleScroll = function handleScroll2(event, targetElement) {
    var clientY = event.targetTouches[0].clientY - initialClientY;
    if (allowTouchMove(event.target)) {
      return false;
    }
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
      return preventDefault(event);
    }
    if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
      return preventDefault(event);
    }
    event.stopPropagation();
    return true;
  };
  var disableBodyScroll = function disableBodyScroll2(targetElement, options) {
    if (!targetElement) {
      console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
      return;
    }
    if (locks.some(function(lock2) {
      return lock2.targetElement === targetElement;
    })) {
      return;
    }
    var lock = {
      targetElement,
      options: options || {}
    };
    locks = [].concat(_toConsumableArray(locks), [lock]);
    if (isIosDevice) {
      setPositionFixed();
    } else {
      setOverflowHidden(options);
    }
    if (isIosDevice) {
      targetElement.ontouchstart = function(event) {
        if (event.targetTouches.length === 1) {
          initialClientY = event.targetTouches[0].clientY;
        }
      };
      targetElement.ontouchmove = function(event) {
        if (event.targetTouches.length === 1) {
          handleScroll(event, targetElement);
        }
      };
      if (!documentListenerAdded) {
        document.addEventListener("touchmove", preventDefault, hasPassiveEvents ? { passive: false } : void 0);
        documentListenerAdded = true;
      }
    }
  };
  var enableBodyScroll = function enableBodyScroll2(targetElement) {
    if (!targetElement) {
      console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
      return;
    }
    locks = locks.filter(function(lock) {
      return lock.targetElement !== targetElement;
    });
    if (isIosDevice) {
      targetElement.ontouchstart = null;
      targetElement.ontouchmove = null;
      if (documentListenerAdded && locks.length === 0) {
        document.removeEventListener("touchmove", preventDefault, hasPassiveEvents ? { passive: false } : void 0);
        documentListenerAdded = false;
      }
    }
    if (isIosDevice) {
      restorePositionSetting();
    } else {
      restoreOverflowSetting();
    }
  };
  var _export_sfc = (sfc, props) => {
    const target = sfc.__vccOpts || sfc;
    for (const [key, val] of props) {
      target[key] = val;
    }
    return target;
  };
  const _sfc_main$F = {};
  const _hoisted_1$n = {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  };
  const _hoisted_2$h = /* @__PURE__ */ vue.createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  }, null, -1);
  const _hoisted_3$f = [
    _hoisted_2$h
  ];
  function _sfc_render$F(_ctx, _cache) {
    return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$n, _hoisted_3$f);
  }
  var CloseIcon = /* @__PURE__ */ _export_sfc(_sfc_main$F, [["render", _sfc_render$F]]);
  const _sfc_main$E = vue.defineComponent({
    name: "Transitionable",
    compatConfig: {
      MODE: 3
    },
    props: {
      classesList: {
        type: Object,
        default: () => ({})
      },
      enabled: {
        type: Boolean,
        default: true
      }
    }
  });
  function _sfc_render$E(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b, _c, _d, _e, _f;
    return vue.openBlock(), vue.createBlock(vue.Transition, {
      "enter-active-class": (_a = _ctx.classesList) == null ? void 0 : _a.enterActiveClass,
      "enter-from-class": (_b = _ctx.classesList) == null ? void 0 : _b.enterFromClass,
      "enter-to-class": (_c = _ctx.classesList) == null ? void 0 : _c.enterToClass,
      "leave-active-class": (_d = _ctx.classesList) == null ? void 0 : _d.leaveActiveClass,
      "leave-from-class": (_e = _ctx.classesList) == null ? void 0 : _e.leaveFromClass,
      "leave-to-class": (_f = _ctx.classesList) == null ? void 0 : _f.leaveToClass,
      css: _ctx.enabled
    }, {
      default: vue.withCtx(() => [
        vue.renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["enter-active-class", "enter-from-class", "enter-to-class", "leave-active-class", "leave-from-class", "leave-to-class", "css"]);
  }
  var Transitionable = /* @__PURE__ */ _export_sfc(_sfc_main$E, [["render", _sfc_render$E]]);
  const _sfc_main$D = vue.defineComponent({
    name: "TModal",
    compatConfig: {
      MODE: 3
    },
    components: {
      CloseIcon,
      Transitionable
    },
    props: __spreadProps(__spreadValues({}, getVariantPropsWithClassesList()), {
      name: {
        type: String,
        default: void 0
      },
      modelValue: {
        type: Boolean,
        default: false
      },
      modalAttributes: {
        type: Object,
        default: () => ({})
      },
      header: {
        type: String,
        default: void 0
      },
      body: {
        type: String,
        default: void 0
      },
      footer: {
        type: String,
        default: void 0
      },
      focusOnOpen: {
        type: Boolean,
        default: true
      },
      clickToClose: {
        type: Boolean,
        default: true
      },
      escToClose: {
        type: Boolean,
        default: true
      },
      disableBodyScroll: {
        type: Boolean,
        default: true
      },
      noBody: {
        type: Boolean,
        default: false
      },
      hideCloseButton: {
        type: Boolean,
        default: false
      },
      bodyScrollLockOptions: {
        type: Object,
        default: () => ({})
      },
      teleport: {
        type: Boolean,
        default: true
      },
      teleportTo: {
        type: [String, Object],
        default: "body"
      }
    }),
    emits: {
      shown: () => true,
      hidden: (reason) => true,
      "before-show": ({ cancel, params }) => true,
      "before-hide": ({ cancel, reason }) => true,
      "update:modelValue": () => true
    },
    setup(props, { emit }) {
      const { configuration, attributes } = useConfigurationWithClassesList(core.TModalConfig, core.TModalClassesKeys);
      const overlay = vue.ref();
      let modalParameters;
      const showModel = useVModel(props, "modelValue");
      const scrollIsDisabled = vue.ref(false);
      const showComponent = vue.ref(showModel.value);
      const showOverlay = vue.ref(showModel.value);
      const showModal = vue.ref(showModel.value);
      const hideReason = vue.ref(core.ModalHideReason.Value);
      const canceled = vue.ref(false);
      const hide = (reason = core.ModalHideReason.Other) => {
        hideReason.value = reason;
        showModel.value = false;
      };
      const show = (params) => {
        modalParameters = params;
        showModel.value = true;
      };
      const focusModal = () => {
        overlay.value.focus();
      };
      const disableBodyScrollIfNeccesary = () => {
        if (!configuration.disableBodyScroll || scrollIsDisabled.value) {
          return;
        }
        disableBodyScroll(overlay.value, configuration.bodyScrollLockOptions);
        scrollIsDisabled.value = true;
      };
      const enableBodyScrollIfNeccesary = () => {
        if (!scrollIsDisabled.value) {
          return;
        }
        enableBodyScroll(overlay.value);
        scrollIsDisabled.value = false;
      };
      const initModal = () => {
        if (configuration.focusOnOpen) {
          focusModal();
        }
        disableBodyScrollIfNeccesary();
      };
      const reset = () => {
        modalParameters = void 0;
        hideReason.value = core.ModalHideReason.Value;
      };
      const onBeforeShow = () => new Promise((resolve, reject) => {
        emit("before-show", {
          cancel: reject,
          params: modalParameters
        });
        resolve();
      });
      const onBeforeHide = () => new Promise((resolve, reject) => {
        emit("before-hide", {
          cancel: reject,
          reason: hideReason.value
        });
        enableBodyScrollIfNeccesary();
        resolve();
      });
      const onShown = () => {
        emit("shown");
        initModal();
      };
      const onHidden = () => {
        emit("hidden", hideReason.value);
        reset();
      };
      vue.watch(showModel, async (isShow) => {
        if (canceled.value) {
          canceled.value = false;
          return;
        }
        if (isShow) {
          try {
            await onBeforeShow();
          } catch (e) {
            canceled.value = true;
            showModel.value = false;
            return;
          }
          showComponent.value = true;
          vue.nextTick(() => {
            showOverlay.value = true;
            vue.nextTick(() => {
              showModal.value = true;
              vue.nextTick(() => {
                onShown();
              });
            });
          });
        } else {
          try {
            await onBeforeHide();
          } catch (e) {
            canceled.value = true;
            showModel.value = true;
            return;
          }
          showModal.value = false;
          vue.nextTick(() => {
            showOverlay.value = false;
            vue.nextTick(() => {
              showComponent.value = false;
              vue.nextTick(() => {
                onHidden();
              });
            });
          });
        }
      });
      const onKeydownEscapeHandler = () => {
        if (!configuration.escToClose) {
          return;
        }
        hide(core.ModalHideReason.Esc);
      };
      const onClickHandler = () => {
        if (!configuration.clickToClose) {
          return;
        }
        hide(core.ModalHideReason.Outside);
      };
      vue.onMounted(() => {
        if (showModel.value) {
          initModal();
        }
      });
      vue.onBeforeUnmount(() => {
        reset();
        enableBodyScrollIfNeccesary();
      });
      if (configuration.name) {
        const emitter = vue.inject("emitter");
        emitter.on("modal:show", (name, params) => {
          if (configuration.name !== name) {
            return;
          }
          show(params);
        });
        emitter.on("modal:hide", (name) => {
          if (configuration.name !== name) {
            return;
          }
          hide(core.ModalHideReason.Method);
        });
      }
      const overlayTransitionClassesList = vue.computed(() => ({
        enterActiveClass: configuration.classesList.overlayEnterActiveClass,
        enterFromClass: configuration.classesList.overlayEnterFromClass,
        enterToClass: configuration.classesList.overlayEnterToClass,
        leaveActiveClass: configuration.classesList.overlayLeaveActiveClass,
        leaveFromClass: configuration.classesList.overlayLeaveFromClass,
        leaveToClass: configuration.classesList.overlayLeaveToClass
      }));
      return {
        configuration,
        attributes,
        showOverlay,
        showModal,
        showComponent,
        overlay,
        overlayTransitionClassesList,
        show,
        hide,
        focusModal,
        onKeydownEscapeHandler,
        onClickHandler,
        ModalHideReason: core.ModalHideReason
      };
    }
  });
  function _sfc_render$D(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_close_icon = vue.resolveComponent("close-icon");
    const _component_transitionable = vue.resolveComponent("transitionable");
    return _ctx.showComponent ? (vue.openBlock(), vue.createBlock(vue.Teleport, {
      key: 0,
      to: _ctx.configuration.teleportTo,
      disabled: !_ctx.configuration.teleport
    }, [
      vue.createVNode(_component_transitionable, { "classes-list": _ctx.overlayTransitionClassesList }, {
        default: vue.withCtx(() => {
          var _a;
          return [
            vue.withDirectives(vue.createElementVNode("div", vue.mergeProps(_ctx.attributes, {
              ref: "overlay",
              tabindex: "0",
              class: (_a = _ctx.configuration.classesList) == null ? void 0 : _a.overlay,
              onKeydown: _cache[2] || (_cache[2] = vue.withKeys((...args) => _ctx.onKeydownEscapeHandler && _ctx.onKeydownEscapeHandler(...args), ["escape"])),
              onClick: _cache[3] || (_cache[3] = (...args) => _ctx.onClickHandler && _ctx.onClickHandler(...args))
            }), [
              vue.createVNode(_component_transitionable, {
                "classes-list": _ctx.configuration.classesList
              }, {
                default: vue.withCtx(() => {
                  var _a2, _b, _c, _d, _e;
                  return [
                    vue.withDirectives(vue.createElementVNode("div", vue.mergeProps(_ctx.configuration.modalAttributes, {
                      ref: "modal",
                      class: (_a2 = _ctx.configuration.classesList) == null ? void 0 : _a2.wrapper,
                      onClick: _cache[1] || (_cache[1] = vue.withModifiers(() => {
                      }, ["stop"]))
                    }), [
                      _ctx.noBody ? vue.renderSlot(_ctx.$slots, "default", { key: 0 }) : (vue.openBlock(), vue.createElementBlock("div", {
                        key: 1,
                        class: vue.normalizeClass((_b = _ctx.configuration.classesList) == null ? void 0 : _b.modal)
                      }, [
                        !_ctx.configuration.hideCloseButton ? vue.renderSlot(_ctx.$slots, "closeButton", {
                          key: 0,
                          hide: _ctx.hide
                        }, () => {
                          var _a3;
                          return [
                            vue.createElementVNode("button", {
                              type: "button",
                              class: vue.normalizeClass((_a3 = _ctx.configuration.classesList) == null ? void 0 : _a3.close),
                              onClick: _cache[0] || (_cache[0] = ($event) => _ctx.hide(_ctx.ModalHideReason.Close))
                            }, [
                              vue.renderSlot(_ctx.$slots, "closeButtonIcon", { hide: _ctx.hide }, () => {
                                var _a4;
                                return [
                                  vue.createVNode(_component_close_icon, {
                                    class: vue.normalizeClass((_a4 = _ctx.configuration.classesList) == null ? void 0 : _a4.closeIcon)
                                  }, null, 8, ["class"])
                                ];
                              })
                            ], 2)
                          ];
                        }) : vue.createCommentVNode("", true),
                        _ctx.$slots.header || _ctx.configuration.header ? (vue.openBlock(), vue.createElementBlock("div", {
                          key: 1,
                          ref: "header",
                          class: vue.normalizeClass((_c = _ctx.configuration.classesList) == null ? void 0 : _c.header)
                        }, [
                          vue.renderSlot(_ctx.$slots, "header", { hide: _ctx.hide }, () => [
                            vue.createTextVNode(vue.toDisplayString(_ctx.configuration.header), 1)
                          ])
                        ], 2)) : vue.createCommentVNode("", true),
                        _ctx.$slots.default || _ctx.configuration.body ? (vue.openBlock(), vue.createElementBlock("div", {
                          key: 2,
                          ref: "body",
                          class: vue.normalizeClass((_d = _ctx.configuration.classesList) == null ? void 0 : _d.body)
                        }, [
                          vue.renderSlot(_ctx.$slots, "default", { hide: _ctx.hide }, () => [
                            vue.createTextVNode(vue.toDisplayString(_ctx.configuration.body), 1)
                          ])
                        ], 2)) : vue.createCommentVNode("", true),
                        _ctx.$slots.footer || _ctx.configuration.footer ? (vue.openBlock(), vue.createElementBlock("div", {
                          key: 3,
                          ref: "footer",
                          class: vue.normalizeClass((_e = _ctx.configuration.classesList) == null ? void 0 : _e.footer)
                        }, [
                          vue.renderSlot(_ctx.$slots, "footer", { hide: _ctx.hide }, () => [
                            vue.createTextVNode(vue.toDisplayString(_ctx.configuration.footer), 1)
                          ])
                        ], 2)) : vue.createCommentVNode("", true)
                      ], 2))
                    ], 16), [
                      [vue.vShow, _ctx.showModal]
                    ])
                  ];
                }),
                _: 3
              }, 8, ["classes-list"])
            ], 16), [
              [vue.vShow, _ctx.showOverlay]
            ])
          ];
        }),
        _: 3
      }, 8, ["classes-list"])
    ], 8, ["to", "disabled"])) : vue.createCommentVNode("", true);
  }
  var TModal = /* @__PURE__ */ _export_sfc(_sfc_main$D, [["render", _sfc_render$D]]);
  const _sfc_main$C = {};
  const _hoisted_1$m = {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  };
  const _hoisted_2$g = /* @__PURE__ */ vue.createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
  }, null, -1);
  const _hoisted_3$e = [
    _hoisted_2$g
  ];
  function _sfc_render$C(_ctx, _cache) {
    return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$m, _hoisted_3$e);
  }
  var CheckCircleIcon = /* @__PURE__ */ _export_sfc(_sfc_main$C, [["render", _sfc_render$C]]);
  const _sfc_main$B = {};
  const _hoisted_1$l = {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  };
  const _hoisted_2$f = /* @__PURE__ */ vue.createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }, null, -1);
  const _hoisted_3$d = [
    _hoisted_2$f
  ];
  function _sfc_render$B(_ctx, _cache) {
    return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$l, _hoisted_3$d);
  }
  var QuestionMarkCircleIcon = /* @__PURE__ */ _export_sfc(_sfc_main$B, [["render", _sfc_render$B]]);
  const _sfc_main$A = {};
  const _hoisted_1$k = {
    xmlns: "http://www.w3.org/2000/svg",
    class: "w-6 h-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  };
  const _hoisted_2$e = /* @__PURE__ */ vue.createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }, null, -1);
  const _hoisted_3$c = [
    _hoisted_2$e
  ];
  function _sfc_render$A(_ctx, _cache) {
    return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$k, _hoisted_3$c);
  }
  var InformationCircleIcon = /* @__PURE__ */ _export_sfc(_sfc_main$A, [["render", _sfc_render$A]]);
  const _sfc_main$z = {};
  const _hoisted_1$j = {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  };
  const _hoisted_2$d = /* @__PURE__ */ vue.createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
  }, null, -1);
  const _hoisted_3$b = [
    _hoisted_2$d
  ];
  function _sfc_render$z(_ctx, _cache) {
    return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$j, _hoisted_3$b);
  }
  var ExclamationIcon = /* @__PURE__ */ _export_sfc(_sfc_main$z, [["render", _sfc_render$z]]);
  const _sfc_main$y = {};
  const _hoisted_1$i = {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  };
  const _hoisted_2$c = /* @__PURE__ */ vue.createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
    "clip-rule": "evenodd"
  }, null, -1);
  const _hoisted_3$a = [
    _hoisted_2$c
  ];
  function _sfc_render$y(_ctx, _cache) {
    return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$i, _hoisted_3$a);
  }
  var SolidCheckCircleIcon = /* @__PURE__ */ _export_sfc(_sfc_main$y, [["render", _sfc_render$y]]);
  const _sfc_main$x = {};
  const _hoisted_1$h = {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  };
  const _hoisted_2$b = /* @__PURE__ */ vue.createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z",
    "clip-rule": "evenodd"
  }, null, -1);
  const _hoisted_3$9 = [
    _hoisted_2$b
  ];
  function _sfc_render$x(_ctx, _cache) {
    return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$h, _hoisted_3$9);
  }
  var SolidQuestionMarkCircleIcon = /* @__PURE__ */ _export_sfc(_sfc_main$x, [["render", _sfc_render$x]]);
  const _sfc_main$w = {};
  const _hoisted_1$g = {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  };
  const _hoisted_2$a = /* @__PURE__ */ vue.createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  }, null, -1);
  const _hoisted_3$8 = [
    _hoisted_2$a
  ];
  function _sfc_render$w(_ctx, _cache) {
    return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$g, _hoisted_3$8);
  }
  var SolidInformationCircleIcon = /* @__PURE__ */ _export_sfc(_sfc_main$w, [["render", _sfc_render$w]]);
  const _sfc_main$v = {};
  const _hoisted_1$f = {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  };
  const _hoisted_2$9 = /* @__PURE__ */ vue.createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
    "clip-rule": "evenodd"
  }, null, -1);
  const _hoisted_3$7 = [
    _hoisted_2$9
  ];
  function _sfc_render$v(_ctx, _cache) {
    return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$f, _hoisted_3$7);
  }
  var SolidExclamationIcon = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["render", _sfc_render$v]]);
  const _sfc_main$u = {};
  const _hoisted_1$e = {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  };
  const _hoisted_2$8 = /* @__PURE__ */ vue.createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
  }, null, -1);
  const _hoisted_3$6 = [
    _hoisted_2$8
  ];
  function _sfc_render$u(_ctx, _cache) {
    return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$e, _hoisted_3$6);
  }
  var CrossCircleIcon = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["render", _sfc_render$u]]);
  const _sfc_main$t = {};
  const _hoisted_1$d = {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  };
  const _hoisted_2$7 = /* @__PURE__ */ vue.createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
    "clip-rule": "evenodd"
  }, null, -1);
  const _hoisted_3$5 = [
    _hoisted_2$7
  ];
  function _sfc_render$t(_ctx, _cache) {
    return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$d, _hoisted_3$5);
  }
  var SolidCrossCircleIcon = /* @__PURE__ */ _export_sfc(_sfc_main$t, [["render", _sfc_render$t]]);
  const _sfc_main$s = {};
  const _hoisted_1$c = {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  };
  const _hoisted_2$6 = /* @__PURE__ */ vue.createElementVNode("circle", {
    cx: "10",
    cy: "10",
    fill: "none",
    r: "8",
    "stroke-width": "2",
    stroke: "currentColor",
    "transform-origin": "center",
    opacity: "0.2"
  }, null, -1);
  const _hoisted_3$4 = /* @__PURE__ */ vue.createElementVNode("circle", {
    cx: "10",
    cy: "10",
    fill: "none",
    r: "8",
    "stroke-width": "2",
    stroke: "currentColor",
    "stroke-dasharray": "80",
    "stroke-dashoffset": "60",
    "transform-origin": "center"
  }, [
    /* @__PURE__ */ vue.createElementVNode("animateTransform", {
      attributeType: "xml",
      attributeName: "transform",
      type: "rotate",
      from: "0",
      to: "360",
      begin: "0",
      dur: "1s",
      repeatCount: "indefinite"
    })
  ], -1);
  const _hoisted_4$1 = [
    _hoisted_2$6,
    _hoisted_3$4
  ];
  function _sfc_render$s(_ctx, _cache) {
    return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$c, _hoisted_4$1);
  }
  var LoadingIcon = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["render", _sfc_render$s]]);
  const _sfc_main$r = vue.defineComponent({
    name: "TDialog",
    compatConfig: {
      MODE: 3
    },
    components: {
      TModal,
      CloseIcon,
      LoadingIcon,
      CrossCircleIcon,
      SolidCrossCircleIcon,
      CheckCircleIcon,
      QuestionMarkCircleIcon,
      InformationCircleIcon,
      ExclamationIcon,
      SolidQuestionMarkCircleIcon,
      SolidInformationCircleIcon,
      SolidExclamationIcon,
      SolidCheckCircleIcon
    },
    props: __spreadProps(__spreadValues({}, getVariantPropsWithClassesList()), {
      type: {
        type: String,
        default: core.DialogType.Alert
      },
      icon: {
        type: String,
        default: void 0
      },
      useSolidIcon: {
        type: Boolean,
        default: false
      },
      rejectOnCancel: {
        type: Boolean,
        default: true
      },
      rejectOnDismiss: {
        type: Boolean,
        default: void 0
      },
      title: {
        type: String,
        default: void 0
      },
      titleTag: {
        type: String,
        default: "h3"
      },
      textTag: {
        type: String,
        default: "p"
      },
      text: {
        type: String,
        default: void 0
      },
      cancelButtonText: {
        type: String,
        default: "Cancel"
      },
      cancelButtonAriaLabel: {
        type: String,
        default: "Cancel"
      },
      okButtonText: {
        type: String,
        default: "OK"
      },
      okButtonAriaLabel: {
        type: String,
        default: "OK"
      },
      preConfirm: {
        type: Function,
        default: void 0
      },
      name: {
        type: String,
        default: void 0
      },
      modelValue: {
        type: Boolean,
        default: false
      },
      dialogAttributes: {
        type: Object,
        default: () => ({})
      },
      focusOnOpen: {
        type: Boolean,
        default: true
      },
      clickToClose: {
        type: Boolean,
        default: true
      },
      escToClose: {
        type: Boolean,
        default: true
      },
      showCloseButton: {
        type: Boolean,
        default: true
      },
      disableBodyScroll: {
        type: Boolean,
        default: true
      },
      bodyScrollLockOptions: {
        type: Object,
        default: () => ({})
      },
      teleport: {
        type: Boolean,
        default: true
      },
      teleportTo: {
        type: [String, Object],
        default: "body"
      },
      inputAttributes: {
        type: Object,
        default: () => ({})
      },
      inputType: {
        type: String,
        default: "text"
      },
      inputValidator: {
        type: Function,
        default: void 0
      },
      inputValue: {
        type: [String, Number, Boolean, Array, Object, Date, Function, Symbol],
        default: void 0
      }
    }),
    emits: {
      shown: () => true,
      hidden: (response) => true,
      error: (response) => true,
      "validation-error": (message) => true,
      "before-show": (e) => true,
      "before-hide": (e) => true,
      "update:modelValue": () => true
    },
    setup(props, { emit }) {
      const { configuration, attributes } = useConfigurationWithClassesList(core.TDialogConfig, core.TDialogClassesKeys);
      const inputWrapperRef = vue.ref();
      const modalRef = vue.ref();
      const showModel = useVModel(props, "modelValue");
      const inputModel = vue.ref(props.inputValue);
      const busy = vue.ref(false);
      const errorMessage = vue.ref(void 0);
      const validationErrorMessage = vue.ref(void 0);
      const hideReason = vue.ref(void 0);
      const dialogResponse = vue.ref(void 0);
      const preConfirmResponse = vue.ref(void 0);
      const promiseResolve = vue.ref(void 0);
      const promiseReject = vue.ref(void 0);
      const isPrompt = vue.computed(() => configuration.type === core.DialogType.Prompt);
      const setError = (error) => {
        if (error instanceof Error) {
          errorMessage.value = error.message;
        } else {
          errorMessage.value = error;
        }
      };
      const setValidationError = (error) => {
        validationErrorMessage.value = error;
      };
      const focusDialog = () => {
        modalRef.value.focusModal();
      };
      const focusPromptInput = () => {
        const focusableField = core.getFocusableElements(inputWrapperRef.value).shift();
        if (focusableField) {
          focusableField.focus();
        } else {
          focusDialog();
        }
      };
      const initDialog = () => {
        if (configuration.focusOnOpen) {
          if (isPrompt.value) {
            focusPromptInput();
          } else {
            focusDialog();
          }
        }
      };
      vue.onMounted(() => {
        if (showModel.value) {
          initDialog();
        }
      });
      const setInputValue = (value) => {
        inputModel.value = value;
      };
      const reset = () => {
        promiseResolve.value = void 0;
        promiseReject.value = void 0;
        hideReason.value = void 0;
        dialogResponse.value = void 0;
        busy.value = false;
        setError(void 0);
        setValidationError(void 0);
        preConfirmResponse.value = void 0;
        setInputValue(props.inputValue);
      };
      const onBeforeShow = (e) => {
        emit("before-show", e);
      };
      const onBeforeHide = (e) => {
        const hideReasonValue = hideReason.value !== void 0 ? hideReason.value : e.reason;
        if (busy.value && hideReasonValue !== core.DialogHideReason.Ok) {
          e.cancel();
          return;
        }
        const response = {
          hideReason: hideReasonValue,
          isOk: hideReasonValue === core.DialogHideReason.Ok,
          isCancel: hideReasonValue === core.DialogHideReason.Cancel,
          isDismissed: ![core.DialogHideReason.Cancel, core.DialogHideReason.Ok].includes(hideReasonValue)
        };
        if (configuration.preConfirm) {
          response.response = preConfirmResponse.value;
        }
        if (isPrompt.value) {
          response.input = inputModel.value;
        }
        dialogResponse.value = response;
        emit("before-hide", {
          cancel: e.cancel,
          response
        });
      };
      const rejectOnDismiss = vue.computed(() => {
        if (configuration.rejectOnDismiss === void 0) {
          return configuration.type !== core.DialogType.Alert;
        }
        return configuration.rejectOnDismiss;
      });
      const onHidden = () => {
        const response = dialogResponse.value;
        emit("hidden", response);
        if (response.isCancel && configuration.rejectOnCancel || response.isDismissed && rejectOnDismiss.value) {
          if (promiseReject.value) {
            promiseReject.value(response);
          }
        } else if (promiseResolve.value) {
          promiseResolve.value(response);
        }
        reset();
      };
      const onShown = () => {
        emit("shown");
        initDialog();
      };
      const hide = (reason = core.DialogHideReason.Other) => {
        hideReason.value = reason;
        showModel.value = false;
      };
      const ok = () => {
        setValidationError(void 0);
        setError(void 0);
        if (configuration.inputValidator && isPrompt.value) {
          const response = configuration.inputValidator(inputModel.value);
          if (typeof response === "string" && response.length > 0) {
            setValidationError(response);
            emit("validation-error", response);
            return;
          }
        }
        if (configuration.preConfirm) {
          const promise = core.promisifyFunctionResult(configuration.preConfirm, inputModel.value);
          busy.value = true;
          promise.then((response) => {
            preConfirmResponse.value = response;
            hide(core.DialogHideReason.Ok);
          }).catch((error) => {
            setError(error);
            emit("error", error);
          }).then(() => {
            busy.value = false;
          });
        } else {
          hide(core.DialogHideReason.Ok);
        }
      };
      const cancel = () => {
        hide(core.DialogHideReason.Cancel);
      };
      const show = () => {
        const promise = new Promise((resolve, reject) => {
          promiseResolve.value = resolve;
          promiseReject.value = reject;
          showModel.value = true;
        });
        return promise;
      };
      if (configuration.name) {
        const emitter = vue.inject("emitter");
        emitter.on("dialog:show", (name, resolve, reject) => {
          if (configuration.name !== name) {
            return;
          }
          promiseResolve.value = resolve;
          promiseReject.value = reject;
          showModel.value = true;
        });
        emitter.on("dialog:hide", (name) => {
          if (configuration.name !== name) {
            return;
          }
          hide(core.DialogHideReason.Method);
        });
      }
      vue.watch(inputModel, () => {
        if (!configuration.inputValidator) {
          return;
        }
        const response = configuration.inputValidator(inputModel.value);
        if (typeof response === "string" && response.length > 0) {
          setValidationError(response);
          emit("validation-error", response);
        } else {
          setValidationError(void 0);
        }
      });
      const modalClasses = vue.computed(() => ({
        overlay: configuration.classesList.overlay,
        wrapper: configuration.classesList.wrapper,
        modal: configuration.classesList.dialog,
        body: configuration.classesList.body,
        footer: configuration.classesList.buttons,
        overlayEnterActiveClass: configuration.classesList.overlayEnterActiveClass,
        overlayEnterFromClass: configuration.classesList.overlayEnterFromClass,
        overlayEnterToClass: configuration.classesList.overlayEnterToClass,
        overlayLeaveActiveClass: configuration.classesList.overlayLeaveActiveClass,
        overlayLeaveFromClass: configuration.classesList.overlayLeaveFromClass,
        overlayLeaveToClass: configuration.classesList.overlayLeaveToClass,
        enterActiveClass: configuration.classesList.enterActiveClass,
        enterFromClass: configuration.classesList.enterFromClass,
        enterToClass: configuration.classesList.enterToClass,
        leaveActiveClass: configuration.classesList.leaveActiveClass,
        leaveFromClass: configuration.classesList.leaveFromClass,
        leaveToClass: configuration.classesList.leaveToClass
      }));
      const showCancelButton = vue.computed(() => configuration.type !== core.DialogType.Alert);
      return {
        configuration,
        attributes,
        showModel,
        modalClasses,
        showCancelButton,
        DialogHideReason: core.DialogHideReason,
        inputModel,
        busy,
        show,
        hide,
        ok,
        cancel,
        onBeforeShow,
        onBeforeHide,
        onShown,
        onHidden,
        setInputValue,
        setError,
        setValidationError,
        errorMessage,
        validationErrorMessage,
        inputWrapperRef,
        modalRef
      };
    }
  });
  const _hoisted_1$b = ["disabled"];
  const _hoisted_2$5 = ["variant", "type"];
  const _hoisted_3$3 = ["aria-label", "disabled"];
  const _hoisted_4 = ["aria-label", "disabled"];
  function _sfc_render$r(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_close_icon = vue.resolveComponent("close-icon");
    const _component_loading_icon = vue.resolveComponent("loading-icon");
    const _component_solid_check_circle_icon = vue.resolveComponent("solid-check-circle-icon");
    const _component_solid_question_mark_circle_icon = vue.resolveComponent("solid-question-mark-circle-icon");
    const _component_solid_information_circle_icon = vue.resolveComponent("solid-information-circle-icon");
    const _component_solid_exclamation_icon = vue.resolveComponent("solid-exclamation-icon");
    const _component_solid_cross_circle_icon = vue.resolveComponent("solid-cross-circle-icon");
    const _component_check_circle_icon = vue.resolveComponent("check-circle-icon");
    const _component_question_mark_circle_icon = vue.resolveComponent("question-mark-circle-icon");
    const _component_information_circle_icon = vue.resolveComponent("information-circle-icon");
    const _component_exclamation_icon = vue.resolveComponent("exclamation-icon");
    const _component_cross_circle_icon = vue.resolveComponent("cross-circle-icon");
    const _component_t_modal = vue.resolveComponent("t-modal");
    return vue.openBlock(), vue.createBlock(_component_t_modal, {
      ref: "modalRef",
      modelValue: _ctx.showModel,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => _ctx.showModel = $event),
      "modal-attributes": _ctx.configuration.dialogAttributes,
      "focus-on-open": false,
      "click-to-close": _ctx.configuration.clickToClose,
      "esc-to-close": _ctx.configuration.escToClose,
      "hide-close-button": !_ctx.configuration.showCloseButton,
      "disable-body-scroll": _ctx.configuration.disableBodyScroll,
      "body-scroll-lock-options": _ctx.configuration.bodyScrollLockOptions,
      teleport: _ctx.configuration.teleport,
      "teleport-to": _ctx.configuration.teleportTo,
      classes: _ctx.modalClasses,
      "fixed-classes": void 0,
      onShown: _ctx.onShown,
      onHidden: _ctx.onHidden,
      onBeforeShow: _ctx.onBeforeShow,
      onBeforeHide: _ctx.onBeforeHide
    }, {
      closeButton: vue.withCtx(() => {
        var _a;
        return [
          !_ctx.configuration.hideCloseButton ? (vue.openBlock(), vue.createElementBlock("button", {
            key: 0,
            type: "button",
            disabled: _ctx.busy,
            class: vue.normalizeClass((_a = _ctx.configuration.classesList) == null ? void 0 : _a.close),
            onClick: _cache[0] || (_cache[0] = ($event) => _ctx.hide(_ctx.DialogHideReason.Close))
          }, [
            vue.renderSlot(_ctx.$slots, "closeButtonIcon", { hide: _ctx.hide }, () => {
              var _a2;
              return [
                vue.createVNode(_component_close_icon, {
                  class: vue.normalizeClass((_a2 = _ctx.configuration.classesList) == null ? void 0 : _a2.closeIcon)
                }, null, 8, ["class"])
              ];
            })
          ], 10, _hoisted_1$b)) : vue.createCommentVNode("", true)
        ];
      }),
      footer: vue.withCtx(() => [
        vue.renderSlot(_ctx.$slots, "footer", {
          hide: _ctx.hide,
          ok: _ctx.ok,
          cancel: _ctx.cancel
        }, () => {
          var _a, _b;
          return [
            _ctx.showCancelButton ? (vue.openBlock(), vue.createElementBlock("button", {
              key: 0,
              ref: "cancelButton",
              type: "button",
              class: vue.normalizeClass((_a = _ctx.configuration.classesList) == null ? void 0 : _a.cancelButton),
              "aria-label": _ctx.cancelButtonAriaLabel,
              disabled: _ctx.busy,
              onClick: _cache[2] || (_cache[2] = (...args) => _ctx.cancel && _ctx.cancel(...args))
            }, vue.toDisplayString(_ctx.cancelButtonText), 11, _hoisted_3$3)) : vue.createCommentVNode("", true),
            vue.createElementVNode("button", {
              ref: "okButton",
              type: "button",
              class: vue.normalizeClass((_b = _ctx.configuration.classesList) == null ? void 0 : _b.okButton),
              "aria-label": _ctx.okButtonAriaLabel,
              disabled: _ctx.busy,
              onClick: _cache[3] || (_cache[3] = (...args) => _ctx.ok && _ctx.ok(...args))
            }, vue.toDisplayString(_ctx.okButtonText), 11, _hoisted_4)
          ];
        })
      ]),
      default: vue.withCtx(() => {
        var _a, _b;
        return [
          _ctx.busy ? (vue.openBlock(), vue.createElementBlock("div", {
            key: 0,
            class: vue.normalizeClass((_a = _ctx.configuration.classesList) == null ? void 0 : _a.busyWrapper)
          }, [
            vue.createVNode(_component_loading_icon, {
              class: vue.normalizeClass((_b = _ctx.configuration.classesList) == null ? void 0 : _b.busyIcon)
            }, null, 8, ["class"])
          ], 2)) : vue.createCommentVNode("", true),
          vue.renderSlot(_ctx.$slots, "default", {
            hide: _ctx.hide,
            ok: _ctx.ok,
            cancel: _ctx.cancel
          }, () => {
            var _a2, _b2, _c, _d, _e, _f, _g, _h, _i;
            return [
              _ctx.errorMessage !== void 0 ? (vue.openBlock(), vue.createElementBlock("div", {
                key: 0,
                class: vue.normalizeClass((_a2 = _ctx.configuration.classesList) == null ? void 0 : _a2.errorMessage)
              }, [
                vue.renderSlot(_ctx.$slots, "error", {
                  setError: _ctx.setError,
                  hide: _ctx.hide,
                  errorMessage: _ctx.errorMessage
                }, () => [
                  vue.createTextVNode(vue.toDisplayString(_ctx.errorMessage), 1)
                ])
              ], 2)) : vue.createCommentVNode("", true),
              _ctx.configuration.icon ? (vue.openBlock(), vue.createElementBlock("div", {
                key: 1,
                ref: "iconWrapperRef",
                class: vue.normalizeClass((_b2 = _ctx.configuration.classesList) == null ? void 0 : _b2.iconWrapper)
              }, [
                vue.renderSlot(_ctx.$slots, "icon", {
                  hide: _ctx.hide,
                  ok: _ctx.ok,
                  cancel: _ctx.cancel
                }, () => {
                  var _a3, _b3, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j;
                  return [
                    _ctx.configuration.useSolidIcon ? (vue.openBlock(), vue.createElementBlock(vue.Fragment, { key: 0 }, [
                      _ctx.configuration.icon === "success" ? (vue.openBlock(), vue.createBlock(_component_solid_check_circle_icon, {
                        key: 0,
                        class: vue.normalizeClass((_a3 = _ctx.configuration.classesList) == null ? void 0 : _a3.icon)
                      }, null, 8, ["class"])) : _ctx.configuration.icon === "question" ? (vue.openBlock(), vue.createBlock(_component_solid_question_mark_circle_icon, {
                        key: 1,
                        class: vue.normalizeClass((_b3 = _ctx.configuration.classesList) == null ? void 0 : _b3.icon)
                      }, null, 8, ["class"])) : _ctx.configuration.icon === "info" ? (vue.openBlock(), vue.createBlock(_component_solid_information_circle_icon, {
                        key: 2,
                        class: vue.normalizeClass((_c2 = _ctx.configuration.classesList) == null ? void 0 : _c2.icon)
                      }, null, 8, ["class"])) : _ctx.configuration.icon === "warning" ? (vue.openBlock(), vue.createBlock(_component_solid_exclamation_icon, {
                        key: 3,
                        class: vue.normalizeClass((_d2 = _ctx.configuration.classesList) == null ? void 0 : _d2.icon)
                      }, null, 8, ["class"])) : _ctx.configuration.icon === "error" ? (vue.openBlock(), vue.createBlock(_component_solid_cross_circle_icon, {
                        key: 4,
                        class: vue.normalizeClass((_e2 = _ctx.configuration.classesList) == null ? void 0 : _e2.icon)
                      }, null, 8, ["class"])) : vue.createCommentVNode("", true)
                    ], 64)) : (vue.openBlock(), vue.createElementBlock(vue.Fragment, { key: 1 }, [
                      _ctx.configuration.icon === "success" ? (vue.openBlock(), vue.createBlock(_component_check_circle_icon, {
                        key: 0,
                        class: vue.normalizeClass((_f2 = _ctx.configuration.classesList) == null ? void 0 : _f2.icon)
                      }, null, 8, ["class"])) : _ctx.configuration.icon === "question" ? (vue.openBlock(), vue.createBlock(_component_question_mark_circle_icon, {
                        key: 1,
                        class: vue.normalizeClass((_g2 = _ctx.configuration.classesList) == null ? void 0 : _g2.icon)
                      }, null, 8, ["class"])) : _ctx.configuration.icon === "info" ? (vue.openBlock(), vue.createBlock(_component_information_circle_icon, {
                        key: 2,
                        class: vue.normalizeClass((_h2 = _ctx.configuration.classesList) == null ? void 0 : _h2.icon)
                      }, null, 8, ["class"])) : _ctx.configuration.icon === "warning" ? (vue.openBlock(), vue.createBlock(_component_exclamation_icon, {
                        key: 3,
                        class: vue.normalizeClass((_i2 = _ctx.configuration.classesList) == null ? void 0 : _i2.icon)
                      }, null, 8, ["class"])) : _ctx.configuration.icon === "error" ? (vue.openBlock(), vue.createBlock(_component_cross_circle_icon, {
                        key: 4,
                        class: vue.normalizeClass((_j = _ctx.configuration.classesList) == null ? void 0 : _j.icon)
                      }, null, 8, ["class"])) : vue.createCommentVNode("", true)
                    ], 64))
                  ];
                })
              ], 2)) : vue.createCommentVNode("", true),
              vue.createElementVNode("div", {
                class: vue.normalizeClass((_c = _ctx.configuration.classesList) == null ? void 0 : _c.content)
              }, [
                _ctx.configuration.title !== void 0 || _ctx.$slots.title ? (vue.openBlock(), vue.createElementBlock("div", {
                  key: 0,
                  class: vue.normalizeClass((_d = _ctx.configuration.classesList) == null ? void 0 : _d.titleWrapper)
                }, [
                  (vue.openBlock(), vue.createBlock(vue.resolveDynamicComponent(_ctx.configuration.titleTag), {
                    class: vue.normalizeClass((_e = _ctx.configuration.classesList) == null ? void 0 : _e.title)
                  }, {
                    default: vue.withCtx(() => [
                      vue.renderSlot(_ctx.$slots, "title", {
                        hide: _ctx.hide,
                        ok: _ctx.ok,
                        cancel: _ctx.cancel
                      }, () => [
                        vue.createTextVNode(vue.toDisplayString(_ctx.configuration.title), 1)
                      ])
                    ]),
                    _: 3
                  }, 8, ["class"]))
                ], 2)) : vue.createCommentVNode("", true),
                _ctx.configuration.text !== void 0 || _ctx.$slots.text ? (vue.openBlock(), vue.createElementBlock("div", {
                  key: 1,
                  class: vue.normalizeClass((_f = _ctx.configuration.classesList) == null ? void 0 : _f.textWrapper)
                }, [
                  (vue.openBlock(), vue.createBlock(vue.resolveDynamicComponent(_ctx.configuration.textTag), {
                    class: vue.normalizeClass((_g = _ctx.configuration.classesList) == null ? void 0 : _g.text)
                  }, {
                    default: vue.withCtx(() => [
                      vue.renderSlot(_ctx.$slots, "text", {
                        hide: _ctx.hide,
                        ok: _ctx.ok,
                        cancel: _ctx.cancel
                      }, () => [
                        vue.createTextVNode(vue.toDisplayString(_ctx.configuration.text), 1)
                      ])
                    ]),
                    _: 3
                  }, 8, ["class"]))
                ], 2)) : vue.createCommentVNode("", true),
                _ctx.configuration.type === "prompt" ? (vue.openBlock(), vue.createElementBlock("div", {
                  key: 2,
                  ref: "inputWrapperRef",
                  class: vue.normalizeClass((_h = _ctx.configuration.classesList) == null ? void 0 : _h.inputWrapper)
                }, [
                  vue.renderSlot(_ctx.$slots, "input", {
                    hide: _ctx.hide,
                    ok: _ctx.ok,
                    cancel: _ctx.cancel,
                    setInputValue: _ctx.setInputValue,
                    inputValue: _ctx.inputValue,
                    variant: _ctx.configuration.inputVariant,
                    inputAttributes: _ctx.configuration.inputAttributes
                  }, () => {
                    var _a3;
                    return [
                      vue.withDirectives(vue.createElementVNode("input", vue.mergeProps({
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.inputModel = $event),
                        variant: _ctx.configuration.inputVariant,
                        type: _ctx.configuration.inputType,
                        class: (_a3 = _ctx.configuration.classesList) == null ? void 0 : _a3.input
                      }, _ctx.configuration.inputAttributes), null, 16, _hoisted_2$5), [
                        [vue.vModelDynamic, _ctx.inputModel]
                      ])
                    ];
                  }),
                  _ctx.validationErrorMessage !== void 0 ? (vue.openBlock(), vue.createElementBlock("div", {
                    key: 0,
                    class: vue.normalizeClass((_i = _ctx.configuration.classesList) == null ? void 0 : _i.inputValidationError)
                  }, [
                    vue.renderSlot(_ctx.$slots, "validation-error", {
                      setError: _ctx.setValidationError,
                      hide: _ctx.hide,
                      errorMessage: _ctx.validationErrorMessage
                    }, () => [
                      vue.createTextVNode(vue.toDisplayString(_ctx.validationErrorMessage), 1)
                    ])
                  ], 2)) : vue.createCommentVNode("", true)
                ], 2)) : vue.createCommentVNode("", true)
              ], 2)
            ];
          })
        ];
      }),
      _: 3
    }, 8, ["modelValue", "modal-attributes", "click-to-close", "esc-to-close", "hide-close-button", "disable-body-scroll", "body-scroll-lock-options", "teleport", "teleport-to", "classes", "onShown", "onHidden", "onBeforeShow", "onBeforeHide"]);
  }
  var TDialog = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["render", _sfc_render$r]]);
  const createDialogProgramatically = (configuration, type, titleOrDialogOptions, text, icon) => {
    const { props } = TDialog;
    if (typeof titleOrDialogOptions === "string") {
      props.title.default = titleOrDialogOptions;
    } else {
      Object.keys(titleOrDialogOptions).forEach((key) => {
        props[key].default = titleOrDialogOptions[key];
      });
    }
    if (typeof text === "string") {
      props.text.default = text;
    }
    if (typeof icon === "string") {
      props.icon.default = icon;
    }
    props.type.default = type;
    const instance = vue.createApp(TDialog);
    instance.provide("configuration", configuration);
    const dialogInstance = instance.mount(document.createElement("div"));
    const promise = dialogInstance.show();
    return promise.then((response) => {
      instance.unmount();
      return Promise.resolve(response);
    }).catch((error) => {
      instance.unmount();
      return Promise.reject(error);
    });
  };
  const plugin = {
    install: (app, configuration = {}) => {
      const emitter = new Emitter();
      app.config.globalProperties.$variantJS = true;
      app.config.globalProperties.$modal = {
        show(name, params) {
          emitter.emit("modal:show", name, params);
        },
        hide(name) {
          emitter.emit("modal:hide", name);
        }
      };
      const alert = (titleOrDialogOptions, text, icon) => createDialogProgramatically(configuration, core.DialogType.Alert, titleOrDialogOptions, text, icon);
      const prompt = (titleOrDialogOptions, text, icon) => createDialogProgramatically(configuration, core.DialogType.Prompt, titleOrDialogOptions, text, icon);
      const confirm = (titleOrDialogOptions, text, icon) => createDialogProgramatically(configuration, core.DialogType.Confirm, titleOrDialogOptions, text, icon);
      app.config.globalProperties.$dialog = {
        show(name) {
          const promise = new Promise((resolve, reject) => {
            emitter.emit("dialog:show", name, resolve, reject);
          });
          return promise;
        },
        hide(name) {
          emitter.emit("dialog:hide", name);
        },
        alert,
        confirm,
        prompt
      };
      app.config.globalProperties.$alert = alert;
      app.config.globalProperties.$confirm = confirm;
      app.config.globalProperties.$prompt = prompt;
      app.provide("configuration", configuration);
      app.provide("emitter", emitter);
    }
  };
  const _sfc_main$q = vue.defineComponent({
    name: "TInput",
    compatConfig: {
      MODE: 3
    },
    props: __spreadProps(__spreadValues({}, getVariantProps()), {
      modelValue: {
        type: [String, Number],
        default: void 0
      }
    }),
    setup(props) {
      const vm = vue.getCurrentInstance();
      const definedProps = vm.vnode.props;
      const usesVModel = definedProps && definedProps.modelValue !== void 0;
      const localValue = useVModel(props, "modelValue");
      const { configuration, attributes } = useConfiguration(core.TInputConfig);
      return {
        localValue,
        configuration,
        attributes,
        usesVModel
      };
    }
  });
  function _sfc_render$q(_ctx, _cache, $props, $setup, $data, $options) {
    return _ctx.usesVModel ? vue.withDirectives((vue.openBlock(), vue.createElementBlock("input", vue.mergeProps({
      key: 0,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.localValue = $event)
    }, _ctx.attributes), null, 16)), [
      [vue.vModelDynamic, _ctx.localValue]
    ]) : (vue.openBlock(), vue.createElementBlock("input", vue.normalizeProps(vue.mergeProps({ key: 1 }, _ctx.attributes)), null, 16));
  }
  var TInput = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["render", _sfc_render$q]]);
  const _sfc_main$p = vue.defineComponent({
    name: "TButton",
    compatConfig: {
      MODE: 3
    },
    props: __spreadProps(__spreadValues({}, getVariantProps()), {
      tagName: {
        type: String,
        default: "button",
        validator: (value) => ["button", "a"].indexOf(value) !== -1
      },
      href: {
        type: String,
        default: void 0
      },
      to: {
        type: [String, Object],
        default: void 0
      },
      replace: {
        type: Boolean,
        default: false
      },
      activeClass: {
        type: String,
        default: void 0
      },
      exactActiveClass: {
        type: String,
        default: void 0
      },
      custom: {
        type: Boolean,
        default: false
      },
      ariaCurrentValue: {
        type: String,
        default: "page"
      }
    }),
    setup() {
      const { configuration, attributes } = useConfiguration(core.TButtonConfig);
      return { configuration, attributes };
    },
    computed: {
      guessedTagName() {
        if (this.configuration.href !== void 0) {
          return "a";
        }
        return this.tagName;
      },
      routerLinkComponentAvailable() {
        return this.routerLinkTag !== null;
      },
      useRouterLink() {
        return this.configuration.to !== void 0 && this.routerLinkComponentAvailable;
      },
      routerLinkTag() {
        const { components } = this.$.appContext;
        if (components.RouterLink !== void 0) {
          return "RouterLink";
        }
        if (components.NuxtLink !== void 0) {
          return "NuxtLink";
        }
        return null;
      }
    }
  });
  function _sfc_render$p(_ctx, _cache, $props, $setup, $data, $options) {
    return _ctx.useRouterLink ? (vue.openBlock(), vue.createBlock(vue.resolveDynamicComponent(_ctx.routerLinkTag), vue.mergeProps({
      key: 0,
      to: _ctx.configuration.to,
      replace: _ctx.configuration.replace,
      "active-class": _ctx.configuration.activeClass,
      "exact-active-class": _ctx.configuration.exactActiveClass,
      custom: _ctx.configuration.custom,
      "aria-current-value": _ctx.configuration.ariaCurrentValue
    }, _ctx.attributes), {
      default: vue.withCtx(() => [
        vue.renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16, ["to", "replace", "active-class", "exact-active-class", "custom", "aria-current-value"])) : (vue.openBlock(), vue.createBlock(vue.resolveDynamicComponent(_ctx.guessedTagName), vue.mergeProps({
      key: 1,
      href: _ctx.configuration.href
    }, _ctx.attributes), {
      default: vue.withCtx(() => [
        vue.renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16, ["href"]));
  }
  var TButton = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["render", _sfc_render$p]]);
  const _sfc_main$o = vue.defineComponent({
    name: "TTextarea",
    compatConfig: {
      MODE: 3
    },
    props: __spreadProps(__spreadValues({}, getVariantProps()), {
      modelValue: {
        type: [String, Number],
        default: void 0
      }
    }),
    setup(props) {
      const vm = vue.getCurrentInstance();
      const definedProps = vm.vnode.props;
      const usesVModel = definedProps && definedProps.modelValue !== void 0;
      const localValue = useVModel(props, "modelValue");
      const { configuration, attributes } = useConfiguration(core.TTextareaConfig);
      return {
        usesVModel,
        localValue,
        configuration,
        attributes
      };
    }
  });
  function _sfc_render$o(_ctx, _cache, $props, $setup, $data, $options) {
    return _ctx.usesVModel ? vue.withDirectives((vue.openBlock(), vue.createElementBlock("textarea", vue.mergeProps({
      key: 0,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.localValue = $event)
    }, _ctx.attributes), null, 16)), [
      [vue.vModelText, _ctx.localValue]
    ]) : (vue.openBlock(), vue.createElementBlock("textarea", vue.normalizeProps(vue.mergeProps({ key: 1 }, _ctx.attributes)), null, 16));
  }
  var TTextarea = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["render", _sfc_render$o]]);
  const _sfc_main$n = vue.defineComponent({
    name: "TSelectOption",
    compatConfig: {
      MODE: 3
    },
    props: {
      option: {
        type: [Object],
        required: true
      }
    },
    computed: {
      hasChildren() {
        return this.option.children !== void 0 && this.option.children.length > 0;
      }
    }
  });
  const _hoisted_1$a = ["data-value", "label", "disabled"];
  const _hoisted_2$4 = ["value", "disabled", "textContent"];
  function _sfc_render$n(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_t_select_option = vue.resolveComponent("t-select-option", true);
    return _ctx.hasChildren ? (vue.openBlock(), vue.createElementBlock("optgroup", {
      key: 0,
      "data-value": _ctx.option.value !== void 0 ? String(_ctx.option.value) : void 0,
      label: _ctx.option.text !== void 0 ? String(_ctx.option.text) : void 0,
      disabled: !!_ctx.option.disabled
    }, [
      (vue.openBlock(true), vue.createElementBlock(vue.Fragment, null, vue.renderList(_ctx.option.children, (childrenOption, index) => {
        return vue.openBlock(), vue.createBlock(_component_t_select_option, {
          key: `${childrenOption.value}-${childrenOption.text}-${index}`,
          option: childrenOption
        }, null, 8, ["option"]);
      }), 128))
    ], 8, _hoisted_1$a)) : (vue.openBlock(), vue.createElementBlock("option", {
      key: 1,
      value: _ctx.option.value === null ? void 0 : _ctx.option.value,
      disabled: !!_ctx.option.disabled,
      textContent: vue.toDisplayString(_ctx.option.text)
    }, null, 8, _hoisted_2$4));
  }
  var TSelectOption = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["render", _sfc_render$n]]);
  function useMulipleableVModel(props, key, configuration) {
    const vm = vue.getCurrentInstance();
    const isMultiple = vue.computed(() => configuration === void 0 ? false : configuration.multiple !== null && configuration.multiple !== void 0 && configuration.multiple !== false);
    const getDefaultValue = () => {
      if (isMultiple.value) {
        return [];
      }
      return void 0;
    };
    const initialValue = props[key];
    const localValue = vue.ref(initialValue === void 0 ? getDefaultValue() : initialValue);
    vue.watch(localValue, (value) => {
      vm == null ? void 0 : vm.emit(`update:${key}`, value);
    });
    vue.watch(() => props[key], (value) => {
      localValue.value = value;
    });
    const clearValue = () => {
      localValue.value = getDefaultValue();
    };
    vue.watch(isMultiple, () => {
      clearValue();
    });
    return {
      localValue,
      clearValue
    };
  }
  function useMultioptions(options, textAttribute, valueAttribute, normalize) {
    const normalizedOptions = vue.computed(() => {
      if (!normalize.value) {
        return options.value;
      }
      return core.normalizeOptions(options.value, textAttribute.value, valueAttribute.value);
    });
    const flattenedOptions = vue.computed(() => core.flattenOptions(normalizedOptions.value));
    return {
      normalizedOptions,
      flattenedOptions
    };
  }
  const _sfc_main$m = vue.defineComponent({
    name: "TSelect",
    compatConfig: {
      MODE: 3
    },
    components: {
      TSelectOption
    },
    props: __spreadProps(__spreadValues({}, getVariantProps()), {
      modelValue: {
        type: [String, Number, Boolean, Array, Object, Date, Function, Symbol],
        default: void 0
      },
      options: {
        type: [Array, Object],
        default: void 0
      },
      normalizeOptions: {
        type: Boolean,
        default: true
      },
      valueAttribute: {
        type: String,
        default: void 0
      },
      textAttribute: {
        type: String,
        default: void 0
      },
      multiple: {
        type: [String, Boolean],
        default: false
      }
    }),
    setup(props) {
      const { configuration, attributes } = useConfiguration(core.TSelectConfig);
      const { localValue } = useMulipleableVModel(props, "modelValue", configuration);
      const {
        normalizedOptions
      } = useMultioptions(vue.computed(() => configuration.options), vue.computed(() => configuration.textAttribute), vue.computed(() => configuration.valueAttribute), vue.computed(() => configuration.normalizeOptions));
      return {
        localValue,
        configuration,
        attributes,
        normalizedOptions
      };
    }
  });
  const _hoisted_1$9 = ["multiple"];
  function _sfc_render$m(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_t_select_option = vue.resolveComponent("t-select-option");
    return vue.withDirectives((vue.openBlock(), vue.createElementBlock("select", vue.mergeProps({
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.localValue = $event),
      multiple: _ctx.configuration.multiple
    }, _ctx.attributes), [
      (vue.openBlock(true), vue.createElementBlock(vue.Fragment, null, vue.renderList(_ctx.normalizedOptions, (option, index) => {
        return vue.openBlock(), vue.createBlock(_component_t_select_option, {
          key: `${option.value}-${index}`,
          option
        }, null, 8, ["option"]);
      }), 128))
    ], 16, _hoisted_1$9)), [
      [vue.vModelSelect, _ctx.localValue]
    ]);
  }
  var TSelect = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["render", _sfc_render$m]]);
  const _sfc_main$l = vue.defineComponent({
    name: "TCheckbox",
    compatConfig: {
      MODE: 3
    },
    props: __spreadProps(__spreadValues({}, getVariantProps()), {
      modelValue: {
        type: [String, Number, Boolean, Array, Object, Date, Function, Symbol],
        default: void 0
      }
    }),
    setup(props) {
      const localValue = useVModel(props, "modelValue");
      const { attributes } = useConfiguration(core.TCheckboxConfig);
      return {
        localValue,
        attributes
      };
    }
  });
  function _sfc_render$l(_ctx, _cache, $props, $setup, $data, $options) {
    return vue.withDirectives((vue.openBlock(), vue.createElementBlock("input", vue.mergeProps({
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.localValue = $event),
      type: "checkbox"
    }, _ctx.attributes), null, 16)), [
      [vue.vModelCheckbox, _ctx.localValue]
    ]);
  }
  var TCheckbox = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["render", _sfc_render$l]]);
  const _sfc_main$k = vue.defineComponent({
    name: "TRadio",
    compatConfig: {
      MODE: 3
    },
    props: __spreadProps(__spreadValues({}, getVariantProps()), {
      modelValue: {
        type: [String, Number, Boolean, Array, Object, Date, Function, Symbol],
        default: void 0
      }
    }),
    setup(props) {
      const localValue = useVModel(props, "modelValue");
      const { configuration, attributes } = useConfiguration(core.TRadioConfig);
      return { localValue, configuration, attributes };
    }
  });
  function _sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
    return vue.withDirectives((vue.openBlock(), vue.createElementBlock("input", vue.mergeProps({
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.localValue = $event),
      type: "radio"
    }, _ctx.attributes), null, 16)), [
      [vue.vModelRadio, _ctx.localValue]
    ]);
  }
  var TRadio = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render$k]]);
  const _sfc_main$j = vue.defineComponent({
    name: "CustomIcon",
    compatConfig: {
      MODE: 3
    },
    props: {
      icon: {
        type: [Object, String],
        required: true
      }
    },
    data() {
      return {
        child: this.icon instanceof Element || typeof this.icon === "string" ? svgToVueComponent(this.icon) : this.icon
      };
    }
  });
  function _sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
    return vue.openBlock(), vue.createBlock(vue.resolveDynamicComponent(_ctx.child));
  }
  var CustomIcon = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$j]]);
  const _sfc_main$i = vue.defineComponent({
    name: "TAlert",
    compatConfig: {
      MODE: 3
    },
    components: {
      CustomIcon,
      CloseIcon,
      Transitionable
    },
    inheritAttrs: false,
    props: __spreadProps(__spreadValues({}, getVariantPropsWithClassesList()), {
      text: {
        type: String,
        default: void 0
      },
      tagName: {
        type: String,
        default: "div"
      },
      bodyTagName: {
        type: String,
        default: "div"
      },
      dismissible: {
        type: Boolean,
        default: true
      },
      show: {
        type: Boolean,
        default: true
      },
      timeout: {
        type: Number,
        default: void 0
      },
      animate: {
        type: Boolean,
        default: true
      },
      closeIcon: {
        type: [Object, String],
        default: void 0
      }
    }),
    emits: {
      "update:show": (show) => typeof show === "boolean"
    },
    setup() {
      const { configuration, attributes } = useConfigurationWithClassesList(core.TAlertConfig, core.TAlertClassesKeys);
      return { configuration, attributes };
    },
    data({ configuration }) {
      return {
        shown: configuration.show,
        timer: null
      };
    },
    watch: {
      shown(shown) {
        this.$emit("update:show", shown);
      },
      "configuration.show": function configurationShowWatch(show) {
        if (show) {
          this.doShow();
        } else {
          this.doHide();
        }
      }
    },
    mounted() {
      if (this.timeout) {
        this.timer = setTimeout(() => this.doHide(), this.timeout);
      }
    },
    unmounted() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    methods: {
      doToggle() {
        if (!this.shown) {
          this.doShow();
        } else {
          this.doHide();
        }
      },
      doShow() {
        this.shown = true;
      },
      doHide() {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.shown = false;
      }
    }
  });
  function _sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_custom_icon = vue.resolveComponent("custom-icon");
    const _component_close_icon = vue.resolveComponent("close-icon");
    const _component_transitionable = vue.resolveComponent("transitionable");
    return vue.openBlock(), vue.createBlock(_component_transitionable, {
      "classes-list": _ctx.configuration.classesList,
      enabled: _ctx.animate
    }, {
      default: vue.withCtx(() => {
        var _a;
        return [
          _ctx.shown ? (vue.openBlock(), vue.createBlock(vue.resolveDynamicComponent(_ctx.tagName), vue.mergeProps({
            key: 0,
            ref: "wrapper",
            class: (_a = _ctx.configuration.classesList) == null ? void 0 : _a.wrapper
          }, _ctx.attributes), {
            default: vue.withCtx(() => {
              var _a2;
              return [
                (vue.openBlock(), vue.createBlock(vue.resolveDynamicComponent(_ctx.bodyTagName), {
                  ref: "body",
                  class: vue.normalizeClass((_a2 = _ctx.configuration.classesList) == null ? void 0 : _a2.body)
                }, {
                  default: vue.withCtx(() => [
                    vue.renderSlot(_ctx.$slots, "default", {
                      show: _ctx.doShow,
                      hide: _ctx.doHide,
                      toggle: _ctx.doToggle,
                      configuration: _ctx.configuration
                    }, () => [
                      vue.createTextVNode(vue.toDisplayString(_ctx.configuration.text), 1)
                    ])
                  ]),
                  _: 3
                }, 8, ["class"])),
                _ctx.dismissible ? vue.renderSlot(_ctx.$slots, "closeButton", {
                  key: 0,
                  show: _ctx.doShow,
                  hide: _ctx.doHide,
                  toggle: _ctx.doToggle,
                  configuration: _ctx.configuration
                }, () => {
                  var _a3, _b;
                  return [
                    vue.createElementVNode("button", {
                      ref: "close",
                      type: "button",
                      class: vue.normalizeClass((_a3 = _ctx.configuration.classesList) == null ? void 0 : _a3.close),
                      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.doHide && _ctx.doHide(...args))
                    }, [
                      _ctx.closeIcon ? (vue.openBlock(), vue.createBlock(_component_custom_icon, {
                        key: 0,
                        ref: "closeIcon",
                        icon: _ctx.closeIcon,
                        class: vue.normalizeClass((_b = _ctx.configuration.classesList) == null ? void 0 : _b.closeIcon)
                      }, null, 8, ["icon", "class"])) : (vue.openBlock(), vue.createBlock(_component_close_icon, {
                        key: 1,
                        ref: "closeIcon"
                      }, null, 512))
                    ], 2)
                  ];
                }) : vue.createCommentVNode("", true)
              ];
            }),
            _: 3
          }, 16, ["class"])) : vue.createCommentVNode("", true)
        ];
      }),
      _: 3
    }, 8, ["classes-list", "enabled"]);
  }
  var TAlert = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$i]]);
  const _sfc_main$h = vue.defineComponent({
    name: "TCard",
    compatConfig: {
      MODE: 3
    },
    props: __spreadProps(__spreadValues({}, getVariantPropsWithClassesList()), {
      tagName: {
        type: String,
        default: "div"
      },
      header: {
        type: String,
        default: void 0
      },
      body: {
        type: String,
        default: void 0
      },
      footer: {
        type: String,
        default: void 0
      }
    }),
    setup() {
      const { configuration, attributes } = useConfigurationWithClassesList(core.TCardConfig, core.TCardClassesKeys);
      return { configuration, attributes };
    }
  });
  function _sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
    var _a;
    return vue.openBlock(), vue.createBlock(vue.resolveDynamicComponent(_ctx.configuration.tagName), vue.mergeProps({
      class: (_a = _ctx.configuration.classesList) == null ? void 0 : _a.wrapper
    }, _ctx.attributes), {
      default: vue.withCtx(() => {
        var _a2, _b, _c;
        return [
          _ctx.$slots.header || _ctx.configuration.header ? (vue.openBlock(), vue.createElementBlock("div", {
            key: 0,
            ref: "header",
            class: vue.normalizeClass((_a2 = _ctx.configuration.classesList) == null ? void 0 : _a2.header)
          }, [
            vue.renderSlot(_ctx.$slots, "header", { configuration: _ctx.configuration }, () => [
              vue.createTextVNode(vue.toDisplayString(_ctx.configuration.header), 1)
            ])
          ], 2)) : vue.createCommentVNode("", true),
          _ctx.$slots.default || _ctx.configuration.body ? (vue.openBlock(), vue.createElementBlock("div", {
            key: 1,
            ref: "body",
            class: vue.normalizeClass((_b = _ctx.configuration.classesList) == null ? void 0 : _b.body)
          }, [
            vue.renderSlot(_ctx.$slots, "default", { configuration: _ctx.configuration }, () => [
              vue.createTextVNode(vue.toDisplayString(_ctx.configuration.body), 1)
            ])
          ], 2)) : vue.createCommentVNode("", true),
          _ctx.$slots.footer || _ctx.configuration.footer ? (vue.openBlock(), vue.createElementBlock("div", {
            key: 2,
            ref: "footer",
            class: vue.normalizeClass((_c = _ctx.configuration.classesList) == null ? void 0 : _c.footer)
          }, [
            vue.renderSlot(_ctx.$slots, "footer", { configuration: _ctx.configuration }, () => [
              vue.createTextVNode(vue.toDisplayString(_ctx.configuration.footer), 1)
            ])
          ], 2)) : vue.createCommentVNode("", true)
        ];
      }),
      _: 3
    }, 16, ["class"]);
  }
  var TCard = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$h]]);
  const validDropdownPlacements = [
    "auto",
    "auto-start",
    "auto-end",
    "top",
    "top-start",
    "top-end",
    "bottom",
    "bottom-start",
    "bottom-end",
    "right",
    "right-start",
    "right-end",
    "left",
    "left-start",
    "left-end"
  ];
  const _sfc_main$g = vue.defineComponent({
    name: "TDropdown",
    compatConfig: {
      MODE: 3
    },
    components: { Transitionable },
    inheritAttrs: false,
    props: __spreadProps(__spreadValues({}, getVariantPropsWithClassesList()), {
      text: {
        type: String,
        default: void 0
      },
      teleport: {
        type: Boolean,
        default: false
      },
      teleportTo: {
        type: [String, Object],
        default: "body"
      },
      tagName: {
        type: String,
        default: "button"
      },
      dropdownTagName: {
        type: String,
        default: "div"
      },
      dropdownAttributes: {
        type: Object,
        default: void 0
      },
      disabled: {
        type: Boolean,
        default: void 0
      },
      toggleOnFocus: {
        type: Boolean,
        default: true
      },
      toggleOnClick: {
        type: Boolean,
        default: true
      },
      toggleOnHover: {
        type: Boolean,
        default: false
      },
      hideOnLeaveTimeout: {
        type: Number,
        default: 250
      },
      show: {
        type: Boolean,
        default: false
      },
      placement: {
        type: String,
        default: void 0,
        validator: (value) => validDropdownPlacements.includes(value)
      },
      popperOptions: {
        type: Object,
        default: () => core.TDropdownPopperDefaultOptions
      }
    }),
    emits: {
      "update:show": (show) => typeof show === "boolean",
      focus: (e) => e instanceof FocusEvent,
      blur: (e) => e instanceof FocusEvent,
      "blur-on-child": (e) => e instanceof FocusEvent,
      click: (e) => e instanceof MouseEvent,
      mouseover: (e) => e instanceof MouseEvent,
      mouseleave: (e) => e instanceof MouseEvent,
      touchstart: (e) => e instanceof TouchEvent,
      shown: () => true,
      hidden: () => true,
      "before-show": () => true,
      "before-hide": () => true
    },
    setup() {
      const { configuration, attributes } = useConfigurationWithClassesList(core.TDropdownConfig, core.TDropdownClassesKeys);
      const isTouchOnlyDevice = vue.ref(false);
      vue.onMounted(() => {
        isTouchOnlyDevice.value = core.isTouchOnlyDevice();
      });
      return { configuration, attributes, isTouchOnlyDevice };
    },
    data({ configuration }) {
      return {
        shown: configuration.show,
        initAsShow: configuration.show,
        hideTimeout: null,
        focusableElements: [],
        throttledToggle: null,
        adjustingPopper: false,
        popperIsAdjusted: false,
        popperAdjusterListener: null,
        popper: null
      };
    },
    computed: {
      fullPopperOptions() {
        const popperOptions = this.configuration.popperOptions;
        if (this.configuration.placement !== void 0) {
          popperOptions.placement = this.configuration.placement;
        }
        return popperOptions;
      },
      shouldShowWhenClicked() {
        return this.isTouchOnlyDevice && (this.configuration.toggleOnFocus === true || this.configuration.toggleOnHover === true);
      }
    },
    watch: {
      popperIsAdjusted(popperIsAdjusted) {
        if (popperIsAdjusted) {
          this.enablePopperNeedsAdjustmentListener();
        } else {
          this.disablePopperNeedsAdjustmentListener();
        }
      },
      "configuration.show": function configurationShowWatch(show) {
        if (show) {
          this.doShow();
        } else {
          this.doHide();
        }
      }
    },
    mounted() {
      if (this.isTouchOnlyDevice && this.shown) {
        window.addEventListener("touchstart", this.touchstartHandler);
      }
      if (this.configuration.show) {
        this.updatePopper().then(() => {
          this.initAsShow = false;
        });
      }
    },
    created() {
      this.throttledToggle = core.throttle(this.doToggle, 200);
      this.popperAdjusterListener = core.debounce(() => {
        this.popperIsAdjusted = false;
      }, 200);
    },
    beforeUnmount() {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
      }
      this.disablePopperNeedsAdjustmentListener();
      if (this.isTouchOnlyDevice && this.shown) {
        window.removeEventListener("touchstart", this.touchstartHandler);
      }
    },
    methods: {
      focus() {
        this.getTriggerElement().focus();
      },
      onShown() {
        this.$emit("shown");
        this.$emit("update:show", true);
        if (this.isTouchOnlyDevice) {
          window.addEventListener("touchstart", this.touchstartHandler);
        } else {
          this.addBlurListenersToChildElements();
        }
      },
      onHidden() {
        this.$emit("hidden");
        this.$emit("update:show", false);
        if (this.isTouchOnlyDevice) {
          window.removeEventListener("touchstart", this.touchstartHandler);
        } else {
          this.removeBlurListenersFromChildElements();
        }
      },
      onBeforeShown() {
        this.$emit("before-show");
        if (this.isTouchOnlyDevice) {
          window.addEventListener("touchstart", this.touchstartHandler);
        }
      },
      onBeforeHide() {
        this.$emit("before-hide");
        if (this.isTouchOnlyDevice) {
          window.removeEventListener("touchstart", this.touchstartHandler);
        }
      },
      addBlurListenersToChildElements() {
        const dropdown = this.getDropdownElement();
        this.focusableElements = core.getFocusableElements(dropdown);
        this.focusableElements.forEach((element) => element.addEventListener("blur", this.blurHandler));
      },
      removeBlurListenersFromChildElements() {
        this.focusableElements.forEach((element) => element.removeEventListener("blur", this.blurHandler));
        this.focusableElements = [];
      },
      dropdownAfterLeave() {
        this.getDropdownElement().style.removeProperty("visibility");
      },
      async adjustPopper() {
        return new Promise(async (resolve) => {
          if (this.shown === false && this.adjustingPopper === false) {
            this.popperIsAdjusted = false;
            resolve();
            return;
          }
          if (!this.popper) {
            this.popper = await this.createPopper();
          }
          await this.popper.update();
          resolve();
        });
      },
      updatePopper() {
        return new Promise(async (resolve) => {
          if (this.popperIsAdjusted) {
            resolve();
            return;
          }
          this.adjustingPopper = true;
          await this.$nextTick();
          await this.adjustPopper();
          this.adjustingPopper = false;
          await this.$nextTick();
          this.popperIsAdjusted = true;
          await this.$nextTick();
          resolve();
        });
      },
      createPopper() {
        let popper;
        return new Promise((resolve) => {
          const popperOptions = this.fullPopperOptions;
          const originalOnFirstUpdate = popperOptions.onFirstUpdate;
          popperOptions.onFirstUpdate = async (arg) => {
            if (originalOnFirstUpdate) {
              originalOnFirstUpdate(arg);
            }
            resolve(popper);
          };
          popper = core$1.createPopper(this.getTriggerElement(), this.getDropdownElement(), this.fullPopperOptions);
        });
      },
      enablePopperNeedsAdjustmentListener() {
        window.addEventListener("resize", this.popperAdjusterListener);
        window.addEventListener("scroll", this.popperAdjusterListener);
      },
      disablePopperNeedsAdjustmentListener() {
        window.removeEventListener("resize", this.popperAdjusterListener);
        window.removeEventListener("scroll", this.popperAdjusterListener);
        this.popperAdjusterListener.cancel();
      },
      getDropdownElement() {
        const { dropdown } = this.$refs;
        return dropdown;
      },
      getTriggerElement() {
        const { trigger } = this.$refs;
        return trigger;
      },
      doToggle() {
        if (!this.shown) {
          this.doShow();
        } else {
          this.doHide();
        }
      },
      async doShow() {
        if (this.hideTimeout) {
          clearTimeout(this.hideTimeout);
        }
        this.onBeforeShown();
        await this.updatePopper();
        this.shown = true;
        await this.$nextTick();
        this.onShown();
      },
      async doHide() {
        this.onBeforeHide();
        this.shown = false;
        await this.$nextTick();
        this.onHidden();
      },
      clickHandler(e) {
        this.$emit("click", e);
        if (this.configuration.toggleOnClick) {
          this.throttledToggle();
        } else if (this.shouldShowWhenClicked) {
          this.doShow();
        }
      },
      focusHandler(e) {
        this.$emit("focus", e);
        if (this.isTouchOnlyDevice) {
          return;
        }
        if (this.configuration.toggleOnFocus) {
          this.throttledToggle();
        }
      },
      blurHandler(e) {
        const isChild = this.targetIsChild(e.relatedTarget);
        if (!isChild) {
          this.$emit("blur", e);
        } else {
          this.$emit("blur-on-child", e);
        }
        if (this.isTouchOnlyDevice) {
          return;
        }
        if (this.configuration.toggleOnFocus && !isChild) {
          this.doHide();
        }
      },
      targetIsChild(target) {
        return core.elementIsTargetOrTargetChild(target, this.getDropdownElement()) || core.elementIsTargetOrTargetChild(target, this.getTriggerElement());
      },
      mouseoverHandler(e) {
        this.$emit("mouseover", e);
        if (this.isTouchOnlyDevice) {
          return;
        }
        if (this.configuration.toggleOnHover) {
          this.doShow();
        }
      },
      mouseleaveHandler(e) {
        this.$emit("mouseleave", e);
        if (this.isTouchOnlyDevice) {
          return;
        }
        if (this.configuration.toggleOnHover && !this.targetIsChild(e.relatedTarget)) {
          this.hideAfterTimeout();
        }
      },
      touchstartHandler(e) {
        this.$emit("touchstart", e);
        if (Array.from(e.targetTouches).some((touch) => this.targetIsChild(touch.target))) {
          return;
        }
        if (this.configuration.toggleOnFocus || this.configuration.toggleOnHover) {
          this.doHide();
        }
      },
      hideAfterTimeout() {
        if (!this.configuration.hideOnLeaveTimeout) {
          this.doHide();
        } else {
          this.hideTimeout = setTimeout(() => {
            this.doHide();
            this.hideTimeout = null;
          }, this.configuration.hideOnLeaveTimeout);
        }
      }
    }
  });
  function _sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
    var _a;
    const _component_transitionable = vue.resolveComponent("transitionable");
    return vue.openBlock(), vue.createElementBlock(vue.Fragment, null, [
      (vue.openBlock(), vue.createBlock(vue.resolveDynamicComponent(_ctx.tagName), vue.mergeProps({
        ref: "trigger",
        type: _ctx.tagName === "button" ? "button" : void 0,
        "aria-expanded": _ctx.shown,
        class: (_a = _ctx.configuration.classesList) == null ? void 0 : _a.trigger,
        disabled: _ctx.configuration.disabled
      }, __spreadValues(__spreadValues({}, _ctx.attributes), _ctx.$attrs), {
        onClick: _ctx.clickHandler,
        onFocus: _ctx.focusHandler,
        onBlur: _ctx.blurHandler,
        onMouseover: _ctx.mouseoverHandler,
        onMouseleave: _ctx.mouseleaveHandler
      }), {
        default: vue.withCtx(() => [
          vue.renderSlot(_ctx.$slots, "trigger", {
            configuration: _ctx.configuration,
            isShow: _ctx.shown,
            popper: _ctx.popper
          }, () => [
            vue.createTextVNode(vue.toDisplayString(_ctx.configuration.text), 1)
          ])
        ]),
        _: 3
      }, 16, ["type", "aria-expanded", "class", "disabled", "onClick", "onFocus", "onBlur", "onMouseover", "onMouseleave"])),
      (vue.openBlock(), vue.createBlock(vue.Teleport, {
        to: _ctx.configuration.teleportTo,
        disabled: !_ctx.configuration.teleport
      }, [
        vue.createVNode(_component_transitionable, {
          enabled: _ctx.popperIsAdjusted || !_ctx.initAsShow,
          "classes-list": _ctx.configuration.classesList,
          onAfterLeave: _ctx.dropdownAfterLeave
        }, {
          default: vue.withCtx(() => {
            var _a2;
            return [
              vue.withDirectives((vue.openBlock(), vue.createBlock(vue.resolveDynamicComponent(_ctx.dropdownTagName), vue.mergeProps({
                ref: "dropdown",
                style: _ctx.adjustingPopper ? "opacity:0" : void 0,
                class: (_a2 = _ctx.configuration.classesList) == null ? void 0 : _a2.dropdown,
                "aria-hidden": !_ctx.shown,
                tabindex: "-1"
              }, _ctx.dropdownAttributes, {
                onBlur: _ctx.blurHandler,
                onMouseover: _ctx.mouseoverHandler,
                onMouseleave: _ctx.mouseleaveHandler
              }), {
                default: vue.withCtx(() => [
                  vue.renderSlot(_ctx.$slots, "default", {
                    show: _ctx.doShow,
                    hide: _ctx.doHide,
                    toggle: _ctx.doToggle,
                    configuration: _ctx.configuration,
                    popper: _ctx.popper
                  })
                ]),
                _: 3
              }, 16, ["style", "class", "aria-hidden", "onBlur", "onMouseover", "onMouseleave"])), [
                [vue.vShow, _ctx.shown || _ctx.adjustingPopper || _ctx.initAsShow]
              ])
            ];
          }),
          _: 3
        }, 8, ["enabled", "classes-list", "onAfterLeave"])
      ], 8, ["to", "disabled"]))
    ], 64);
  }
  var TDropdown = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$g]]);
  const _sfc_main$f = vue.defineComponent({
    name: "TInputGroup",
    compatConfig: {
      MODE: 3
    },
    props: __spreadProps(__spreadValues({}, getVariantPropsWithClassesList()), {
      label: {
        type: String,
        default: void 0
      },
      description: {
        type: String,
        default: void 0
      },
      feedback: {
        type: String,
        default: void 0
      },
      body: {
        type: String,
        default: void 0
      },
      tagName: {
        type: String,
        default: "div"
      },
      bodyTagName: {
        type: String,
        default: "div"
      },
      labelTagName: {
        type: String,
        default: "label"
      },
      feedbackTagName: {
        type: String,
        default: "div"
      },
      descriptionTagName: {
        type: String,
        default: "div"
      },
      sortedElements: {
        type: Array,
        default: () => ["label", "default", "feedback", "description"],
        validator: (value) => {
          const expectedValues = ["default", "description", "feedback", "label"];
          return value.every((key) => expectedValues.find((k) => k === key) !== null);
        }
      }
    }),
    setup() {
      const { configuration, attributes } = useConfigurationWithClassesList(core.TInputGroupConfig, core.TInputGroupClassesKeys);
      return { configuration, attributes };
    },
    computed: {
      elementsToRender() {
        const { configuration } = this;
        const slots = this.$slots;
        return this.sortedElements.filter((e) => e === "default" ? !!configuration.body || !!slots.default : !!configuration[e] || !!slots[e]).map((e) => ({
          name: e,
          tagName: e === "default" ? configuration.bodyTagName : configuration[`${e}TagName`]
        }));
      }
    }
  });
  function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
    var _a;
    return vue.openBlock(), vue.createBlock(vue.resolveDynamicComponent(_ctx.tagName), vue.mergeProps({
      ref: "wrapper",
      class: (_a = _ctx.configuration.classesList) == null ? void 0 : _a.wrapper
    }, _ctx.attributes), {
      default: vue.withCtx(() => [
        (vue.openBlock(true), vue.createElementBlock(vue.Fragment, null, vue.renderList(_ctx.elementsToRender, (element) => {
          var _a2;
          return vue.openBlock(), vue.createBlock(vue.resolveDynamicComponent(element.tagName), {
            key: element.name,
            ref_for: true,
            ref: element.name,
            class: vue.normalizeClass((_a2 = _ctx.configuration.classesList) == null ? void 0 : _a2[element.name === "default" ? "body" : element.name])
          }, {
            default: vue.withCtx(() => [
              _ctx.$slots[element.name] ? vue.renderSlot(_ctx.$slots, element.name, { key: 0 }) : (vue.openBlock(), vue.createElementBlock(vue.Fragment, { key: 1 }, [
                vue.createTextVNode(vue.toDisplayString(_ctx.configuration[element.name === "default" ? "body" : element.name]), 1)
              ], 64))
            ]),
            _: 2
          }, 1032, ["class"]);
        }), 128))
      ]),
      _: 3
    }, 16, ["class"]);
  }
  var TInputGroup = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$f]]);
  function useActivableOption(options, localValue) {
    const getActiveOption = () => {
      const selectedOption = options.value.find((option) => core.isEqual(option.value, localValue.value) && !core.normalizedOptionIsDisabled(option));
      if (selectedOption !== void 0) {
        return selectedOption;
      }
      if (options.value.length > 0) {
        return options.value.find((option) => !core.normalizedOptionIsDisabled(option)) || null;
      }
      return null;
    };
    const activeOption = vue.ref(getActiveOption());
    const activeOptionIndex = vue.computed(() => {
      if (activeOption.value === null) {
        return 0;
      }
      const index = options.value.findIndex((option) => core.isEqual(option.value, activeOption.value.value));
      return index < 0 ? 0 : index;
    });
    const optionIsActive = (option) => activeOption.value === null ? false : core.isEqual(activeOption.value.value, option.value);
    const setActiveOption = (option) => {
      activeOption.value = option;
    };
    const setNextOptionActive = () => {
      let newActiveOption;
      let nextIndex = activeOptionIndex.value + 1;
      while (nextIndex < options.value.length && newActiveOption === void 0) {
        const option = options.value[nextIndex];
        const optionIsDisabled = core.normalizedOptionIsDisabled(option);
        if (!optionIsDisabled) {
          newActiveOption = option;
        }
        nextIndex += 1;
      }
      if (newActiveOption) {
        setActiveOption(newActiveOption);
      }
    };
    const setPrevOptionActive = () => {
      let newActiveOption;
      let nextIndex = activeOptionIndex.value - 1;
      while (nextIndex >= 0 && newActiveOption === void 0) {
        const option = options.value[nextIndex];
        const optionIsDisabled = core.normalizedOptionIsDisabled(option);
        if (!optionIsDisabled) {
          newActiveOption = option;
        }
        nextIndex -= 1;
      }
      if (newActiveOption) {
        setActiveOption(newActiveOption);
      }
    };
    const initActiveOption = () => {
      activeOption.value = getActiveOption();
    };
    vue.watch(options, (newOptions, oldOptions) => {
      const firstNewOption = newOptions.find((o) => !oldOptions.includes(o) && !core.normalizedOptionIsDisabled(o));
      if (firstNewOption) {
        setActiveOption(firstNewOption);
      } else {
        initActiveOption();
      }
    });
    return {
      activeOption,
      initActiveOption,
      optionIsActive,
      setActiveOption,
      setNextOptionActive,
      setPrevOptionActive
    };
  }
  function useFetchsOptions(localValue, options, textAttribute, valueAttribute, normalize, searchQuery, fetchFn, prefetchFn, fetchDelay, fetchMinimumInputLength, fetchMinimumInputLengthText) {
    const { emit } = vue.getCurrentInstance();
    const getNormalizedOptions = (rawOptions) => normalize.value ? core.normalizeOptions(rawOptions, textAttribute.value, valueAttribute.value) : rawOptions;
    const fetchedOptions = vue.ref(getNormalizedOptions(options.value || []));
    vue.watch(options, () => {
      fetchedOptions.value = getNormalizedOptions(options.value || []);
    });
    const optionsWereFetched = vue.ref(false);
    const normalizedOptions = vue.computed(() => {
      if (typeof fetchFn.value !== "function" && typeof prefetchFn.value !== "function") {
        const normalized = getNormalizedOptions(options.value || []);
        if (searchQuery.value) {
          return core.filterOptions(normalized, searchQuery.value);
        }
        return normalized;
      }
      return fetchedOptions.value;
    });
    const flattenedOptions = vue.computed(() => core.flattenOptions(normalizedOptions.value));
    const fetchsOptions = vue.computed(() => fetchFn.value !== void 0);
    const needsMoreCharsToFetch = vue.computed(() => {
      if (!fetchsOptions.value) {
        return false;
      }
      if (!fetchMinimumInputLength.value) {
        return false;
      }
      return !searchQuery.value || searchQuery.value.length < fetchMinimumInputLength.value;
    });
    const fetchNextPage = vue.ref(void 0);
    const fetchingOptions = vue.ref(false);
    const fetchingMoreOptions = vue.ref(false);
    const fetchedOptionsHaveMorePages = vue.computed(() => fetchNextPage.value !== void 0);
    const fetchOptionsFn = ([nextPage]) => {
      fetchFn.value(searchQuery.value, nextPage).then((response) => {
        if (typeof response === "object" && Object.prototype.hasOwnProperty.call(response, "results")) {
          const { results, hasMorePages } = response;
          if (!Array.isArray(results) && results !== void 0 && typeof results !== "object") {
            throw new Error(`Response.results must be an array or object, got ${typeof results}`);
          }
          if (nextPage !== void 0 && nextPage >= 2) {
            fetchedOptions.value = fetchedOptions.value.concat(getNormalizedOptions(results));
          } else {
            fetchedOptions.value = getNormalizedOptions(results);
          }
          if (hasMorePages) {
            fetchNextPage.value = fetchNextPage.value === void 0 ? 2 : fetchNextPage.value + 1;
          } else {
            fetchNextPage.value = void 0;
          }
        } else {
          throw new Error("Options response must be an object with `results` property.");
        }
        optionsWereFetched.value = true;
        emit("fetch-options-success", response);
      }).catch((error) => {
        emit("fetch-options-error", error);
      }).then(() => {
        fetchingOptions.value = false;
        fetchingMoreOptions.value = false;
      });
    };
    const debouncedFetchOptions = core.debounce(fetchOptionsFn, fetchDelay.value);
    const fetchOptionsCancel = () => {
      debouncedFetchOptions.cancel();
      fetchingOptions.value = false;
      fetchingMoreOptions.value = false;
    };
    const fetchOptions = (nextPage) => {
      if (!fetchsOptions.value) {
        fetchOptionsCancel();
        return;
      }
      if (nextPage !== void 0 && nextPage >= 2) {
        fetchingMoreOptions.value = true;
      } else {
        fetchingOptions.value = true;
      }
      debouncedFetchOptions(nextPage);
    };
    const fetchMoreOptions = () => {
      fetchOptions(fetchNextPage.value);
    };
    vue.watch(searchQuery, () => {
      if (!fetchsOptions.value || needsMoreCharsToFetch.value) {
        return;
      }
      optionsWereFetched.value = false;
      fetchOptions();
    });
    const needsMoreCharsMessage = vue.computed(() => {
      if (typeof fetchMinimumInputLengthText.value === "string") {
        return fetchMinimumInputLengthText.value;
      }
      return fetchMinimumInputLengthText.value(fetchMinimumInputLength.value, searchQuery.value);
    });
    const prefetchOptions = () => {
      if (typeof prefetchFn.value !== "function") {
        fetchOptions();
        return;
      }
      fetchingOptions.value = true;
      prefetchFn.value(localValue.value).then((results) => {
        if (!Array.isArray(results) && results !== void 0 && typeof results !== "object") {
          throw new Error(`Response must be an array or object, got ${typeof results}`);
        }
        fetchedOptions.value = getNormalizedOptions(results);
        optionsWereFetched.value = true;
        emit("fetch-options-success", results);
      }).catch((error) => {
        emit("fetch-options-error", error);
      }).then(() => {
        fetchingOptions.value = false;
      });
    };
    return {
      normalizedOptions,
      flattenedOptions,
      fetchsOptions,
      needsMoreCharsToFetch,
      needsMoreCharsMessage,
      fetchingOptions,
      fetchingMoreOptions,
      fetchedOptionsHaveMorePages,
      optionsWereFetched,
      fetchOptions,
      prefetchOptions,
      fetchMoreOptions,
      fetchOptionsCancel
    };
  }
  function useSelectableOption(options, localValue, multiple) {
    const optionIsSelected = (option) => {
      if (multiple.value === true) {
        return Array.isArray(localValue.value) && localValue.value.some((value) => core.isEqual(value, option.value));
      }
      return core.isEqual(localValue.value, option.value);
    };
    const getSelectedOption = (currentSelectedOption) => {
      let allOptions = options.value;
      if (Array.isArray(currentSelectedOption)) {
        allOptions = allOptions.filter((option) => !currentSelectedOption.some((selectedOption2) => core.isEqual(selectedOption2.value, option.value))).concat(currentSelectedOption);
      } else if (currentSelectedOption !== void 0) {
        allOptions = allOptions.filter((option) => !core.isEqual(currentSelectedOption.value, option.value)).concat([currentSelectedOption]);
      }
      if (multiple.value === true) {
        if (Array.isArray(localValue.value)) {
          return allOptions.filter((option) => optionIsSelected(option));
        }
        return [];
      }
      return allOptions.find((option) => optionIsSelected(option));
    };
    const selectedOption = vue.ref(getSelectedOption());
    const selectOption = (option) => {
      if (optionIsSelected(option)) {
        return;
      }
      if (multiple.value === true) {
        if (Array.isArray(localValue.value)) {
          localValue.value = core.addToArray(localValue.value, option.value);
          selectedOption.value = core.addToArray(selectedOption.value, option);
        } else {
          localValue.value = [option.value];
          selectedOption.value = [option];
        }
      } else {
        localValue.value = option.value;
        selectedOption.value = option;
      }
    };
    const toggleOption = (option) => {
      if (optionIsSelected(option)) {
        if (multiple.value === true) {
          localValue.value = core.substractFromArray(localValue.value, option.value);
        } else {
          localValue.value = void 0;
        }
      } else if (multiple.value === true) {
        if (Array.isArray(localValue.value)) {
          localValue.value = core.addToArray(localValue.value, option.value);
        } else {
          localValue.value = [option.value];
        }
      } else {
        localValue.value = option.value;
      }
    };
    vue.watch([options, localValue], () => {
      selectedOption.value = getSelectedOption(selectedOption.value);
    });
    const hasSelectedOption = vue.computed(() => {
      if (multiple.value === true) {
        return selectedOption.value.length > 0;
      }
      return selectedOption.value !== void 0;
    });
    return {
      selectedOption,
      hasSelectedOption,
      selectOption,
      toggleOption,
      optionIsSelected
    };
  }
  function useInjectsConfiguration() {
    return vue.inject("configuration", {});
  }
  function useInjectsClassesListClass(property) {
    const configuration = useInjectsConfiguration();
    return vue.computed(() => core.get(configuration.classesList, property, ""));
  }
  const _sfc_main$e = vue.defineComponent({
    name: "TextPlaceholder",
    compatConfig: {
      MODE: 3
    },
    props: {
      classProperty: {
        type: String,
        default: "placeholder"
      },
      placeholder: {
        type: String,
        default: void 0
      }
    },
    setup(props) {
      const className = useInjectsClassesListClass(props.classProperty);
      return { className };
    }
  });
  const _hoisted_1$8 = /* @__PURE__ */ vue.createTextVNode("\xA0");
  function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
    return vue.openBlock(), vue.createElementBlock("span", {
      class: vue.normalizeClass(_ctx.className)
    }, [
      vue.renderSlot(_ctx.$slots, "default", {}, () => [
        _ctx.placeholder !== void 0 ? (vue.openBlock(), vue.createElementBlock(vue.Fragment, { key: 0 }, [
          vue.createTextVNode(vue.toDisplayString(_ctx.placeholder), 1)
        ], 64)) : (vue.openBlock(), vue.createElementBlock(vue.Fragment, { key: 1 }, [
          _hoisted_1$8
        ], 64))
      ])
    ], 2);
  }
  var TextPlaceholder = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$e]]);
  function useInjectsClassesList() {
    const configuration = useInjectsConfiguration();
    return vue.computed(() => configuration.classesList || {});
  }
  const _sfc_main$d = vue.defineComponent({
    name: "RichSelectTriggerTagsTag",
    compatConfig: {
      MODE: 3
    },
    components: {
      CloseIcon
    },
    props: {
      option: {
        type: Object,
        required: true
      }
    },
    setup() {
      const toggleOption = vue.inject("toggleOption");
      const classesList = useInjectsClassesList();
      return { toggleOption, classesList };
    },
    computed: {
      dataValueAttribute() {
        if (typeof this.option.value === "object") {
          return JSON.stringify(this.option.value);
        }
        return String(this.option.value);
      },
      isDisabled() {
        return core.normalizedOptionIsDisabled(this.option);
      }
    },
    methods: {
      focus() {
        this.$el.focus();
      },
      getElementIndex() {
        const elements = Array.from(this.$el.parentElement.children);
        return Array.from(elements).findIndex((el) => el.isSameNode(this.$el));
      },
      focusNextElement() {
        const { parentElement } = this.$el;
        const currentElementIndex = this.getElementIndex();
        const elements = Array.from(parentElement.children);
        if (currentElementIndex < elements.length - 1) {
          elements[currentElementIndex + 1].focus();
        }
      },
      focusPrevElement() {
        const { parentElement } = this.$el;
        const currentElementIndex = this.getElementIndex();
        const elements = Array.from(parentElement.children);
        if (currentElementIndex > 0) {
          elements[currentElementIndex - 1].focus();
        }
      },
      async unselect() {
        const { parentElement } = this.$el;
        const elementIndex = this.getElementIndex();
        this.toggleOption(this.option);
        await this.$nextTick();
        const nextElement = parentElement.children[elementIndex];
        if (nextElement) {
          nextElement.focus();
        } else if (elementIndex > 0) {
          parentElement.children[elementIndex - 1].focus();
        }
      }
    }
  });
  const _hoisted_1$7 = ["disabled", "data-value"];
  function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_close_icon = vue.resolveComponent("close-icon");
    return vue.openBlock(), vue.createElementBlock("button", {
      type: "button",
      class: vue.normalizeClass(_ctx.classesList.tag),
      disabled: _ctx.isDisabled,
      "data-rich-select-focusable": "",
      "data-rich-select-tag": "",
      "data-value": _ctx.dataValueAttribute,
      onMousedown: _cache[3] || (_cache[3] = vue.withModifiers((...args) => _ctx.focus && _ctx.focus(...args), ["prevent", "stop"])),
      onKeydown: [
        _cache[4] || (_cache[4] = vue.withKeys(vue.withModifiers((...args) => _ctx.unselect && _ctx.unselect(...args), ["prevent", "stop"]), ["backspace"])),
        _cache[5] || (_cache[5] = vue.withKeys(vue.withModifiers((...args) => _ctx.focusNextElement && _ctx.focusNextElement(...args), ["prevent", "stop"]), ["right"])),
        _cache[6] || (_cache[6] = vue.withKeys(vue.withModifiers((...args) => _ctx.focusPrevElement && _ctx.focusPrevElement(...args), ["prevent", "stop"]), ["left"])),
        _cache[7] || (_cache[7] = vue.withKeys(vue.withModifiers(() => {
        }, ["prevent", "stop"]), ["enter"]))
      ]
    }, [
      vue.createElementVNode("span", {
        class: vue.normalizeClass(_ctx.classesList.tagLabel)
      }, [
        vue.renderSlot(_ctx.$slots, "tagLabel", {
          option: _ctx.option,
          isDisabled: _ctx.isDisabled
        }, () => [
          vue.createTextVNode(vue.toDisplayString(_ctx.option.text), 1)
        ])
      ], 2),
      !_ctx.isDisabled ? (vue.openBlock(), vue.createElementBlock("span", {
        key: 0,
        tabindex: "0",
        class: vue.normalizeClass(_ctx.classesList.tagDeleteButton),
        "data-rich-select-focusable": "",
        onMousedown: _cache[0] || (_cache[0] = vue.withModifiers((...args) => _ctx.unselect && _ctx.unselect(...args), ["prevent", "stop"])),
        onKeydown: [
          _cache[1] || (_cache[1] = vue.withKeys(vue.withModifiers((...args) => _ctx.unselect && _ctx.unselect(...args), ["prevent", "stop"]), ["backspace"])),
          _cache[2] || (_cache[2] = vue.withKeys(vue.withModifiers((...args) => _ctx.unselect && _ctx.unselect(...args), ["prevent", "stop"]), ["enter"]))
        ]
      }, [
        vue.renderSlot(_ctx.$slots, "tagCloseIcon", { option: _ctx.option }, () => [
          vue.createVNode(_component_close_icon, {
            ref: "closeIcon",
            class: vue.normalizeClass(_ctx.classesList.tagDeleteButtonIcon)
          }, null, 8, ["class"])
        ])
      ], 34)) : vue.createCommentVNode("", true)
    ], 42, _hoisted_1$7);
  }
  var RichSelectTriggerTagsTag = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["render", _sfc_render$d]]);
  const _sfc_main$c = vue.defineComponent({
    name: "RichSelectTriggerTags",
    compatConfig: {
      MODE: 3
    },
    components: {
      RichSelectTriggerTagsTag
    },
    setup() {
      const selectedOptions = vue.inject("selectedOption");
      const className = useInjectsClassesListClass("tagsWrapper");
      return {
        selectedOptions,
        className
      };
    }
  });
  function _sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_rich_select_trigger_tags_tag = vue.resolveComponent("rich-select-trigger-tags-tag");
    return vue.openBlock(), vue.createElementBlock("div", {
      class: vue.normalizeClass(_ctx.className)
    }, [
      (vue.openBlock(true), vue.createElementBlock(vue.Fragment, null, vue.renderList(_ctx.selectedOptions, (option, index) => {
        return vue.openBlock(), vue.createBlock(_component_rich_select_trigger_tags_tag, {
          key: `${option.value}-${index}`,
          option
        }, {
          tagCloseIcon: vue.withCtx((props) => [
            vue.renderSlot(_ctx.$slots, "tagCloseIcon", vue.normalizeProps(vue.guardReactiveProps(props)))
          ]),
          tagLabel: vue.withCtx((props) => [
            vue.renderSlot(_ctx.$slots, "tagLabel", vue.normalizeProps(vue.guardReactiveProps(props)))
          ]),
          _: 2
        }, 1032, ["option"]);
      }), 128))
    ], 2);
  }
  var RichSelectTriggerTags = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$c]]);
  const _sfc_main$b = {};
  const _hoisted_1$6 = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  };
  const _hoisted_2$3 = /* @__PURE__ */ vue.createElementVNode("path", {
    "clip-rule": "evenodd",
    "fill-rule": "evenodd",
    d: "M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
  }, null, -1);
  const _hoisted_3$2 = [
    _hoisted_2$3
  ];
  function _sfc_render$b(_ctx, _cache) {
    return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$6, _hoisted_3$2);
  }
  var SelectorIcon = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["render", _sfc_render$b]]);
  const _sfc_main$a = vue.defineComponent({
    name: "RichSelectTrigger",
    compatConfig: {
      MODE: 3
    },
    components: {
      RichSelectTriggerTags,
      TextPlaceholder,
      SelectorIcon,
      LoadingIcon
    },
    setup() {
      const configuration = useInjectsConfiguration();
      const selectedOption = vue.inject("selectedOption");
      const hasSelectedOption = vue.inject("hasSelectedOption");
      const fetchingOptions = vue.inject("fetchingOptions");
      const shown = vue.inject("shown");
      const usesTags = vue.inject("usesTags");
      const classesList = useInjectsClassesList();
      return {
        selectedOption,
        hasSelectedOption,
        configuration,
        fetchingOptions,
        shown,
        usesTags,
        classesList
      };
    },
    computed: {
      label() {
        if (!this.hasSelectedOption) {
          return void 0;
        }
        if (this.multiple) {
          return this.selectedOption.map((o) => o.text).join(", ");
        }
        return String(this.selectedOption.text);
      },
      isFetchingOptionsWhileClosed() {
        return this.fetchingOptions && !this.shown;
      },
      multiple() {
        return Array.isArray(this.selectedOption);
      },
      showSelectorIcon() {
        if (this.isFetchingOptionsWhileClosed) {
          return false;
        }
        if (!this.configuration.clearable) {
          return true;
        }
        return !this.hasSelectedOption || this.configuration.disabled === true;
      }
    }
  });
  function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_text_placeholder = vue.resolveComponent("text-placeholder");
    const _component_loading_icon = vue.resolveComponent("loading-icon");
    const _component_rich_select_trigger_tags = vue.resolveComponent("rich-select-trigger-tags");
    const _component_selector_icon = vue.resolveComponent("selector-icon");
    return vue.openBlock(), vue.createElementBlock(vue.Fragment, null, [
      _ctx.isFetchingOptionsWhileClosed || !_ctx.hasSelectedOption ? vue.renderSlot(_ctx.$slots, "placeholder", {
        key: 0,
        isFetchingOptionsWhileClosed: _ctx.isFetchingOptionsWhileClosed
      }, () => [
        _ctx.isFetchingOptionsWhileClosed ? (vue.openBlock(), vue.createElementBlock(vue.Fragment, { key: 0 }, [
          vue.createVNode(_component_text_placeholder, {
            ref: "fetchingPlaceholder",
            "class-property": "selectButtonSearchingPlaceholder",
            placeholder: _ctx.configuration.loadingClosedPlaceholder
          }, null, 8, ["placeholder"]),
          vue.createVNode(_component_loading_icon, {
            ref: "loadingIcon",
            class: vue.normalizeClass(_ctx.classesList.selectButtonLoadingIcon)
          }, null, 8, ["class"])
        ], 64)) : (vue.openBlock(), vue.createBlock(_component_text_placeholder, {
          key: 1,
          ref: "placeholder",
          "class-property": "selectButtonPlaceholder",
          placeholder: _ctx.configuration.placeholder
        }, null, 8, ["placeholder"]))
      ]) : _ctx.usesTags ? (vue.openBlock(), vue.createBlock(_component_rich_select_trigger_tags, { key: 1 }, {
        tagCloseIcon: vue.withCtx((props) => [
          vue.renderSlot(_ctx.$slots, "tagCloseIcon", vue.normalizeProps(vue.guardReactiveProps(props)))
        ]),
        tagLabel: vue.withCtx((props) => [
          vue.renderSlot(_ctx.$slots, "tagLabel", vue.normalizeProps(vue.guardReactiveProps(props)))
        ]),
        _: 3
      })) : (vue.openBlock(), vue.createElementBlock("span", {
        key: 2,
        ref: "label",
        class: vue.normalizeClass(_ctx.classesList.selectButtonLabel)
      }, [
        vue.renderSlot(_ctx.$slots, "label", {
          label: _ctx.label,
          selectedOption: _ctx.selectedOption
        }, () => [
          vue.createTextVNode(vue.toDisplayString(_ctx.label), 1)
        ])
      ], 2)),
      _ctx.showSelectorIcon ? vue.renderSlot(_ctx.$slots, "selectorIcon", { key: 3 }, () => [
        vue.createVNode(_component_selector_icon, {
          ref: "selectorIcon",
          class: vue.normalizeClass(_ctx.classesList.selectButtonSelectorIcon)
        }, null, 8, ["class"])
      ]) : vue.createCommentVNode("", true)
    ], 64);
  }
  var RichSelectTrigger = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$a]]);
  const _sfc_main$9 = {};
  const _hoisted_1$5 = {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  };
  const _hoisted_2$2 = /* @__PURE__ */ vue.createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
    "clip-rule": "evenodd"
  }, null, -1);
  const _hoisted_3$1 = [
    _hoisted_2$2
  ];
  function _sfc_render$9(_ctx, _cache) {
    return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1$5, _hoisted_3$1);
  }
  var CheckmarkIcon = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$9]]);
  const _sfc_main$8 = vue.defineComponent({
    name: "RichSelectOption",
    compatConfig: {
      MODE: 3
    },
    components: {
      CheckmarkIcon
    },
    props: {
      option: {
        type: [Object],
        required: true
      },
      deep: {
        type: Number,
        default: 0
      }
    },
    setup() {
      const toggleOption = vue.inject("toggleOption");
      const setActiveOption = vue.inject("setActiveOption");
      const optionIsSelected = vue.inject("optionIsSelected");
      const optionIsActive = vue.inject("optionIsActive");
      const shown = vue.inject("shown");
      const classesList = useInjectsClassesList();
      return {
        setActiveOption,
        toggleOption,
        optionIsSelected,
        optionIsActive,
        shown,
        classesList
      };
    },
    computed: {
      optionClasses() {
        const classes = [this.classesList.option];
        if (this.isSelected) {
          if (this.isActive) {
            classes.push(this.classesList.selectedHighlightedOption);
          } else {
            classes.push(this.classesList.selectedOption);
          }
        } else if (this.isActive) {
          classes.push(this.classesList.highlightedOption);
        }
        return classes;
      },
      valueAttribute() {
        if (typeof this.option.value === "object") {
          return JSON.stringify(this.option.value);
        }
        return String(this.option.value);
      },
      hasChildren() {
        return this.option.children !== void 0 && this.option.children.length > 0;
      },
      isSelected() {
        return this.optionIsSelected(this.option);
      },
      isActive() {
        return this.optionIsActive(this.option);
      },
      isDisabled() {
        return core.normalizedOptionIsDisabled(this.option);
      }
    },
    watch: {
      shown: {
        async handler() {
          await this.$nextTick();
          this.scrollIntoViewIfNeccesary();
        },
        immediate: true
      },
      isActive() {
        this.scrollIntoViewIfNeccesary();
      }
    },
    beforeCreate() {
      this.$options.components.RichSelectOptionsList = vue.defineAsyncComponent(() => Promise.resolve().then(function() {
        return RichSelectOptionsList$1;
      }));
    },
    methods: {
      scrollIntoViewIfNeccesary() {
        if (this.shown && this.isActive) {
          const li = this.$el;
          li.scrollIntoView({ block: "nearest", behavior: "smooth" });
        }
      },
      mousemoveHandler() {
        if (this.isDisabled) {
          return;
        }
        this.setActiveOption(this.option);
      },
      mousewheelHandler() {
        if (this.isDisabled) {
          return;
        }
        this.setActiveOption(this.option);
      },
      clickHandler() {
        if (this.isDisabled) {
          return;
        }
        this.toggleOption(this.option);
      }
    }
  });
  const _hoisted_1$4 = ["aria-selected", "disabled", "value"];
  function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_rich_select_options_list = vue.resolveComponent("rich-select-options-list");
    const _component_checkmark_icon = vue.resolveComponent("checkmark-icon");
    return _ctx.hasChildren ? (vue.openBlock(), vue.createElementBlock("li", {
      key: 0,
      role: "optgroup",
      class: vue.normalizeClass(_ctx.classesList.optgroup)
    }, [
      vue.createElementVNode("div", {
        class: vue.normalizeClass(_ctx.classesList.optgroupContent)
      }, [
        vue.createElementVNode("span", {
          class: vue.normalizeClass(_ctx.classesList.optgroupLabel)
        }, vue.toDisplayString(_ctx.option.text), 3),
        vue.createVNode(_component_rich_select_options_list, {
          ref: "childrenOptions",
          class: vue.normalizeClass(_ctx.classesList.optgroupOptionsList),
          options: _ctx.option.children,
          deep: _ctx.deep + 1
        }, null, 8, ["class", "options", "deep"])
      ], 2)
    ], 2)) : (vue.openBlock(), vue.createElementBlock("li", {
      key: 1,
      class: vue.normalizeClass(_ctx.classesList.optionWrapper),
      onMousemove: _cache[0] || (_cache[0] = (...args) => _ctx.mousemoveHandler && _ctx.mousemoveHandler(...args)),
      onMousewheel: _cache[1] || (_cache[1] = (...args) => _ctx.mousewheelHandler && _ctx.mousewheelHandler(...args)),
      onClick: _cache[2] || (_cache[2] = (...args) => _ctx.clickHandler && _ctx.clickHandler(...args))
    }, [
      vue.renderSlot(_ctx.$slots, "option", {
        className: _ctx.optionClasses,
        option: _ctx.option,
        isDisabled: _ctx.isDisabled,
        isActive: _ctx.isActive,
        isSelected: _ctx.isSelected,
        deep: _ctx.deep
      }, () => [
        vue.createElementVNode("button", {
          role: "option",
          class: vue.normalizeClass(_ctx.optionClasses),
          "aria-selected": _ctx.isSelected,
          tabindex: "-1",
          type: "button",
          disabled: _ctx.isDisabled,
          value: _ctx.valueAttribute
        }, [
          vue.createElementVNode("div", {
            class: vue.normalizeClass(_ctx.classesList.optionContent)
          }, [
            vue.renderSlot(_ctx.$slots, "optionLabel", {
              option: _ctx.option,
              isDisabled: _ctx.isDisabled,
              isActive: _ctx.isActive,
              isSelected: _ctx.isSelected,
              deep: _ctx.deep
            }, () => [
              vue.createElementVNode("span", {
                class: vue.normalizeClass(_ctx.classesList.optionLabel)
              }, vue.toDisplayString(_ctx.option.text), 3)
            ]),
            vue.renderSlot(_ctx.$slots, "optionIcon", {
              className: _ctx.optionClasses,
              option: _ctx.option,
              isDisabled: _ctx.isDisabled,
              isActive: _ctx.isActive,
              isSelected: _ctx.isSelected,
              deep: _ctx.deep
            }, () => [
              _ctx.isSelected ? (vue.openBlock(), vue.createBlock(_component_checkmark_icon, {
                key: 0,
                ref: "checkIcon",
                class: vue.normalizeClass(_ctx.classesList.optionSelectedIcon)
              }, null, 8, ["class"])) : vue.createCommentVNode("", true)
            ])
          ], 2)
        ], 10, _hoisted_1$4)
      ])
    ], 34));
  }
  var RichSelectOption = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$8]]);
  const _sfc_main$7 = vue.defineComponent({
    name: "RichSelectOptionsList",
    compatConfig: {
      MODE: 3
    },
    components: {
      RichSelectOption
    },
    props: {
      options: {
        type: Array,
        required: true
      },
      deep: {
        type: Number,
        default: 0
      }
    },
    setup(props) {
      const configuration = vue.inject("configuration");
      const shown = vue.inject("shown");
      const fetchingMoreOptions = vue.inject("fetchingMoreOptions");
      const dropdownBottomReachedHandler = vue.inject("dropdownBottomReachedHandler");
      const maxHeight = vue.computed(() => core.normalizeMeasure(configuration.maxHeight));
      const usesMaxHeight = vue.computed(() => props.deep === 0 && maxHeight.value !== void 0);
      const classesList = useInjectsClassesList();
      const bottomReachedObserver = core.debounce(([event]) => {
        const element = event.target;
        const reached = Math.ceil(element.scrollHeight - element.scrollTop) === element.clientHeight;
        if (reached) {
          dropdownBottomReachedHandler();
        }
      }, 200);
      return {
        maxHeight,
        usesMaxHeight,
        shown,
        bottomReachedObserver,
        fetchingMoreOptions,
        configuration,
        classesList
      };
    },
    computed: {
      showOptions() {
        return this.options.length > 0;
      }
    },
    watch: {
      async showOptions(show) {
        if (show) {
          await this.$nextTick();
          this.$el.addEventListener("scroll", this.bottomReachedObserver);
        } else {
          this.$el.removeEventListener("scroll", this.bottomReachedObserver);
        }
      },
      async fetchingMoreOptions(fetchingMoreOptions) {
        if (fetchingMoreOptions) {
          await this.$nextTick();
          const el = this.$refs.fetchingMoreOptionsText;
          el.scrollIntoView({ block: "end", behavior: "smooth" });
        }
      }
    },
    mounted() {
      if (this.showOptions) {
        this.$el.addEventListener("scroll", this.bottomReachedObserver);
      }
    },
    beforeUnmount() {
      if (this.showOptions) {
        this.$el.removeEventListener("scroll", this.bottomReachedObserver);
      }
    }
  });
  const _hoisted_1$3 = ["textContent"];
  function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_rich_select_option = vue.resolveComponent("rich-select-option");
    return _ctx.showOptions ? (vue.openBlock(), vue.createElementBlock("ul", {
      key: 0,
      class: vue.normalizeClass(_ctx.classesList.optionsList),
      style: vue.normalizeStyle(_ctx.usesMaxHeight ? `max-height: ${_ctx.maxHeight}; overflow-x: auto;` : void 0)
    }, [
      (vue.openBlock(true), vue.createElementBlock(vue.Fragment, null, vue.renderList(_ctx.options, (option, index) => {
        return vue.openBlock(), vue.createBlock(_component_rich_select_option, {
          key: `${_ctx.deep > 0 ? `${_ctx.deep}-` : ""}${JSON.stringify(option.value)}-${index}`,
          option,
          deep: _ctx.deep
        }, {
          option: vue.withCtx((props) => [
            vue.renderSlot(_ctx.$slots, "option", vue.normalizeProps(vue.guardReactiveProps(props)))
          ]),
          optionLabel: vue.withCtx((props) => [
            vue.renderSlot(_ctx.$slots, "optionLabel", vue.normalizeProps(vue.guardReactiveProps(props)))
          ]),
          optionIcon: vue.withCtx((props) => [
            vue.renderSlot(_ctx.$slots, "optionIcon", vue.normalizeProps(vue.guardReactiveProps(props)))
          ]),
          _: 2
        }, 1032, ["option", "deep"]);
      }), 128)),
      _ctx.fetchingMoreOptions ? (vue.openBlock(), vue.createElementBlock("li", {
        ref: "fetchingMoreOptionsText",
        key: "loading_more",
        class: vue.normalizeClass(_ctx.classesList.optionsListLoadingMore),
        textContent: vue.toDisplayString(_ctx.configuration.loadingMoreResultsText)
      }, null, 10, _hoisted_1$3)) : vue.createCommentVNode("", true)
    ], 6)) : vue.createCommentVNode("", true);
  }
  var RichSelectOptionsList = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$7]]);
  var RichSelectOptionsList$1 = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    [Symbol.toStringTag]: "Module",
    "default": RichSelectOptionsList
  });
  const _sfc_main$6 = vue.defineComponent({
    name: "RichSelectSearchInput",
    compatConfig: {
      MODE: 3
    },
    setup() {
      const search = vue.ref();
      const shown = vue.inject("shown");
      const searchQuery = vue.inject("searchQuery");
      const configuration = useInjectsConfiguration();
      const keydownDownHandler = vue.inject("keydownDownHandler");
      const keydownUpHandler = vue.inject("keydownUpHandler");
      const keydownEnterHandler = vue.inject("keydownEnterHandler");
      const keydownEscHandler = vue.inject("keydownEscHandler");
      const classesList = useInjectsClassesList();
      vue.watch(shown, async (isShown) => {
        if (isShown) {
          search.value.focus();
        }
      });
      return {
        configuration,
        shown,
        search,
        searchQuery,
        classesList,
        keydownUpHandler,
        keydownDownHandler,
        keydownEnterHandler,
        keydownEscHandler
      };
    }
  });
  const _hoisted_1$2 = ["placeholder"];
  function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
    return vue.openBlock(), vue.createElementBlock("div", {
      class: vue.normalizeClass(_ctx.classesList.searchWrapper)
    }, [
      vue.withDirectives(vue.createElementVNode("input", {
        ref: "search",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.searchQuery = $event),
        "data-rich-select-focusable": "",
        placeholder: _ctx.configuration.searchBoxPlaceholder,
        class: vue.normalizeClass(_ctx.classesList.searchInput),
        onKeydown: [
          _cache[1] || (_cache[1] = vue.withKeys((...args) => _ctx.keydownDownHandler && _ctx.keydownDownHandler(...args), ["down"])),
          _cache[2] || (_cache[2] = vue.withKeys((...args) => _ctx.keydownUpHandler && _ctx.keydownUpHandler(...args), ["up"])),
          _cache[3] || (_cache[3] = vue.withKeys((...args) => _ctx.keydownEnterHandler && _ctx.keydownEnterHandler(...args), ["enter"])),
          _cache[4] || (_cache[4] = vue.withKeys((...args) => _ctx.keydownEscHandler && _ctx.keydownEscHandler(...args), ["esc"]))
        ]
      }, null, 42, _hoisted_1$2), [
        [vue.vModelText, _ctx.searchQuery]
      ])
    ], 2);
  }
  var RichSelectSearchInput = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$6]]);
  const _sfc_main$5 = vue.defineComponent({
    name: "RichSelectState",
    compatConfig: {
      MODE: 3
    },
    setup() {
      const options = vue.inject("options");
      const fetchingOptions = vue.inject("fetchingOptions");
      const needsMoreCharsToFetch = vue.inject("needsMoreCharsToFetch");
      const needsMoreCharsMessage = vue.inject("needsMoreCharsMessage");
      const configuration = useInjectsConfiguration();
      const noResults = vue.computed(() => options.value.length === 0);
      const classesList = useInjectsClassesList();
      return {
        noResults,
        configuration,
        fetchingOptions,
        needsMoreCharsToFetch,
        needsMoreCharsMessage,
        classesList
      };
    }
  });
  const _hoisted_1$1 = ["textContent"];
  const _hoisted_2$1 = ["textContent"];
  const _hoisted_3 = ["textContent"];
  function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
    return vue.renderSlot(_ctx.$slots, "stateFeedback", {
      fetchingOptions: _ctx.fetchingOptions,
      needsMoreCharsToFetch: _ctx.needsMoreCharsToFetch,
      noResults: _ctx.noResults
    }, () => [
      _ctx.fetchingOptions ? (vue.openBlock(), vue.createElementBlock("div", {
        key: 0,
        class: vue.normalizeClass(_ctx.classesList.searchingText),
        textContent: vue.toDisplayString(_ctx.configuration.searchingText)
      }, null, 10, _hoisted_1$1)) : _ctx.needsMoreCharsToFetch ? (vue.openBlock(), vue.createElementBlock("div", {
        key: 1,
        class: vue.normalizeClass(_ctx.classesList.needsMoreCharsText),
        textContent: vue.toDisplayString(_ctx.needsMoreCharsMessage)
      }, null, 10, _hoisted_2$1)) : _ctx.noResults ? (vue.openBlock(), vue.createElementBlock("div", {
        key: 2,
        class: vue.normalizeClass(_ctx.classesList.noResultsText),
        textContent: vue.toDisplayString(_ctx.configuration.noResultsText)
      }, null, 10, _hoisted_3)) : vue.createCommentVNode("", true)
    ]);
  }
  var RichSelectState = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$5]]);
  const _sfc_main$4 = vue.defineComponent({
    name: "RichSelectDropdown",
    compatConfig: {
      MODE: 3
    },
    components: {
      RichSelectOptionsList,
      RichSelectSearchInput,
      RichSelectState
    },
    setup() {
      const options = vue.inject("options");
      const showSearchInput = vue.inject("showSearchInput");
      const className = useInjectsClassesListClass("dropdownContent");
      return {
        options,
        showSearchInput,
        className
      };
    }
  });
  function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_rich_select_search_input = vue.resolveComponent("rich-select-search-input");
    const _component_rich_select_state = vue.resolveComponent("rich-select-state");
    const _component_rich_select_options_list = vue.resolveComponent("rich-select-options-list");
    return vue.openBlock(), vue.createElementBlock("div", {
      class: vue.normalizeClass(_ctx.className)
    }, [
      _ctx.showSearchInput ? (vue.openBlock(), vue.createBlock(_component_rich_select_search_input, {
        key: 0,
        ref: "searchInput"
      }, null, 512)) : vue.createCommentVNode("", true),
      vue.renderSlot(_ctx.$slots, "dropdownTop"),
      vue.createVNode(_component_rich_select_state, { ref: "state" }, {
        stateFeedback: vue.withCtx((props) => [
          vue.renderSlot(_ctx.$slots, "stateFeedback", vue.normalizeProps(vue.guardReactiveProps(props)))
        ]),
        _: 3
      }, 512),
      vue.createVNode(_component_rich_select_options_list, {
        ref: "optionsList",
        options: _ctx.options
      }, {
        option: vue.withCtx((props) => [
          vue.renderSlot(_ctx.$slots, "option", vue.normalizeProps(vue.guardReactiveProps(props)))
        ]),
        optionLabel: vue.withCtx((props) => [
          vue.renderSlot(_ctx.$slots, "optionLabel", vue.normalizeProps(vue.guardReactiveProps(props)))
        ]),
        optionIcon: vue.withCtx((props) => [
          vue.renderSlot(_ctx.$slots, "optionIcon", vue.normalizeProps(vue.guardReactiveProps(props)))
        ]),
        _: 3
      }, 8, ["options"]),
      vue.renderSlot(_ctx.$slots, "dropdownButton")
    ], 2);
  }
  var RichSelectDropdown = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4]]);
  const _sfc_main$3 = vue.defineComponent({
    name: "RichSelectClearButton",
    compatConfig: {
      MODE: 3
    },
    components: {
      CloseIcon
    },
    setup() {
      const className = useInjectsClassesListClass("clearButton");
      return { className };
    }
  });
  function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_close_icon = vue.resolveComponent("close-icon");
    return vue.openBlock(), vue.createElementBlock("button", {
      type: "button",
      "data-rich-select-focusable": "",
      class: vue.normalizeClass(_ctx.className)
    }, [
      vue.renderSlot(_ctx.$slots, "clearButton", {}, () => [
        vue.createVNode(_component_close_icon, { class: "w-4 h-4" })
      ])
    ], 2);
  }
  var RichSelectClearButton = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3]]);
  const _sfc_main$2 = vue.defineComponent({
    name: "TRichSelect",
    compatConfig: {
      MODE: 3
    },
    components: {
      RichSelectTrigger,
      RichSelectDropdown,
      RichSelectClearButton,
      TDropdown,
      TSelect
    },
    props: __spreadProps(__spreadValues({}, getVariantPropsWithClassesList()), {
      modelValue: {
        type: [
          String,
          Number,
          Boolean,
          Array,
          Object,
          Date,
          Function,
          Symbol
        ],
        default: void 0
      },
      name: {
        type: String,
        default: void 0
      },
      options: {
        type: [Array, Object],
        default: void 0
      },
      normalizeOptions: {
        type: Boolean,
        default: true
      },
      multiple: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      tags: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: void 0
      },
      dropdownPlacement: {
        type: String,
        default: void 0,
        validator: (value) => validDropdownPlacements.includes(value)
      },
      dropdownPopperOptions: {
        type: Object,
        default: () => __spreadProps(__spreadValues({}, core.TDropdownPopperDefaultOptions), {
          placement: "bottom",
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 8]
              }
            },
            sameWidthModifier
          ]
        })
      },
      closeOnSelect: {
        type: Boolean,
        default: void 0
      },
      selectOnClose: {
        type: Boolean,
        default: false
      },
      clearSearchOnClose: {
        type: Boolean,
        default: void 0
      },
      toggleOnFocus: {
        type: Boolean,
        default: false
      },
      toggleOnClick: {
        type: Boolean,
        default: true
      },
      valueAttribute: {
        type: String,
        default: void 0
      },
      textAttribute: {
        type: String,
        default: void 0
      },
      hideSearchBox: {
        type: Boolean,
        default: false
      },
      searchBoxPlaceholder: {
        type: String,
        default: "Search..."
      },
      noResultsText: {
        type: String,
        default: "No options found"
      },
      searchingText: {
        type: String,
        default: "Searching..."
      },
      loadingClosedPlaceholder: {
        type: String,
        default: "Loading..."
      },
      loadingMoreResultsText: {
        type: String,
        default: "Loading more options..."
      },
      clearable: {
        type: Boolean,
        default: true
      },
      maxHeight: {
        type: [Number, String],
        default: 250
      },
      fetchOptions: {
        type: Function,
        default: void 0
      },
      prefetchOptions: {
        type: [Function, Boolean],
        default: false
      },
      delay: {
        type: Number,
        default: 250
      },
      minimumInputLength: {
        type: Number,
        default: void 0
      },
      minimumInputLengthText: {
        type: [Function, String],
        default: () => (minimumInputLength) => `Please enter ${minimumInputLength} or more characters`
      },
      minimumResultsForSearch: {
        type: Number,
        default: void 0
      },
      teleport: {
        type: Boolean,
        default: false
      },
      teleportTo: {
        type: [String, Object],
        default: "body"
      }
    }),
    emits: {
      change: (e) => e instanceof CustomEvent,
      input: (e) => e instanceof CustomEvent,
      keydown: (e) => e instanceof KeyboardEvent,
      focus: (e) => e instanceof FocusEvent,
      blur: (e) => e instanceof FocusEvent,
      mousedown: (e) => e instanceof MouseEvent,
      mouseover: (e) => e instanceof MouseEvent,
      mouseleave: (e) => e instanceof MouseEvent,
      touchstart: (e) => e instanceof TouchEvent,
      shown: () => true,
      hidden: () => true,
      "before-show": () => true,
      "before-hide": () => true,
      "fetch-options-success": () => true,
      "fetch-options-error": () => true,
      "update:modelValue": () => true
    },
    setup(props, { emit }) {
      const { configuration, attributes } = useConfigurationWithClassesList(core.TRichSelectConfig, core.TRichSelectClassesKeys);
      const { localValue, clearValue } = useMulipleableVModel(props, "modelValue", configuration);
      const searchQuery = vue.ref(void 0);
      const {
        normalizedOptions,
        flattenedOptions,
        fetchsOptions,
        needsMoreCharsToFetch,
        needsMoreCharsMessage,
        fetchingOptions,
        fetchingMoreOptions,
        fetchOptions: doFetchOptions,
        prefetchOptions: doPrefetchOptions,
        fetchMoreOptions,
        optionsWereFetched,
        fetchedOptionsHaveMorePages,
        fetchOptionsCancel
      } = useFetchsOptions(localValue, vue.computed(() => configuration.options), vue.computed(() => configuration.textAttribute), vue.computed(() => configuration.valueAttribute), vue.computed(() => configuration.normalizeOptions), searchQuery, vue.computed(() => configuration.fetchOptions), vue.computed(() => configuration.prefetchOptions), vue.computed(() => configuration.delay), vue.computed(() => configuration.minimumInputLength), vue.computed(() => configuration.minimumInputLengthText));
      const {
        selectedOption,
        hasSelectedOption,
        selectOption,
        toggleOption,
        optionIsSelected
      } = useSelectableOption(flattenedOptions, localValue, vue.computed(() => configuration.multiple));
      const {
        activeOption,
        optionIsActive,
        setActiveOption,
        initActiveOption,
        setNextOptionActive,
        setPrevOptionActive
      } = useActivableOption(flattenedOptions, localValue);
      const shown = vue.ref(false);
      const showSearchInput = vue.computed(() => {
        if (configuration.hideSearchBox) {
          return false;
        }
        if (configuration.minimumResultsForSearch !== void 0) {
          return normalizedOptions.value.length >= configuration.minimumResultsForSearch;
        }
        return true;
      });
      const dropdownComponent = vue.ref();
      const focusDropdownTrigger = () => {
        dropdownComponent.value.focus();
      };
      const usesTags = vue.computed(() => configuration.tags === true && configuration.multiple === true);
      const hideDropdown = () => {
        dropdownComponent.value.doHide();
      };
      const showDropdown = () => {
        dropdownComponent.value.doShow();
      };
      const adjustDropdown = async () => {
        await dropdownComponent.value.adjustPopper();
      };
      const throttledShowDropdown = core.throttle(showDropdown, 200);
      const toggleDropdown = () => {
        if (shown.value) {
          hideDropdown();
        } else {
          throttledShowDropdown();
        }
      };
      const toggleOptionFromActiveOption = () => {
        if (activeOption.value === null) {
          return;
        }
        toggleOption(activeOption.value);
      };
      const selectOptionFromActiveOption = () => {
        if (activeOption.value === null) {
          return;
        }
        selectOption(activeOption.value);
      };
      const keydownDownHandler = (e) => {
        emit("keydown", e);
        e.preventDefault();
        if (shown.value === false) {
          throttledShowDropdown();
        } else {
          setNextOptionActive();
          const lastOption = normalizedOptions.value[normalizedOptions.value.length - 1];
          if (optionIsActive(lastOption) && fetchedOptionsHaveMorePages.value && !fetchingMoreOptions.value) {
            fetchMoreOptions();
          }
        }
      };
      const keydownUpHandler = (e) => {
        emit("keydown", e);
        e.preventDefault();
        if (shown.value === false) {
          throttledShowDropdown();
        } else {
          setPrevOptionActive();
        }
      };
      const keydownEnterHandler = (e) => {
        emit("keydown", e);
        if (shown.value === true) {
          toggleOptionFromActiveOption();
        }
      };
      const keydownSpaceHandler = (e) => {
        emit("keydown", e);
        e.preventDefault();
        if (configuration.toggleOnClick && shown.value === false) {
          throttledShowDropdown();
        } else if (shown.value === true) {
          toggleOptionFromActiveOption();
        }
      };
      const keydownEscHandler = (e) => {
        emit("keydown", e);
        if (shown.value === false) {
          return;
        }
        hideDropdown();
        focusDropdownTrigger();
      };
      const dropdownBottomReachedHandler = () => {
        if (fetchedOptionsHaveMorePages.value && !fetchingMoreOptions.value) {
          fetchMoreOptions();
        }
      };
      vue.provide("configuration", configuration);
      vue.provide("options", normalizedOptions);
      vue.provide("selectedOption", selectedOption);
      vue.provide("hasSelectedOption", hasSelectedOption);
      vue.provide("toggleOption", toggleOption);
      vue.provide("setActiveOption", setActiveOption);
      vue.provide("optionIsSelected", optionIsSelected);
      vue.provide("optionIsActive", optionIsActive);
      vue.provide("keydownDownHandler", keydownDownHandler);
      vue.provide("keydownUpHandler", keydownUpHandler);
      vue.provide("keydownEscHandler", keydownEscHandler);
      vue.provide("keydownEnterHandler", keydownEnterHandler);
      vue.provide("shown", shown);
      vue.provide("showSearchInput", showSearchInput);
      vue.provide("searchQuery", searchQuery);
      vue.provide("needsMoreCharsToFetch", needsMoreCharsToFetch);
      vue.provide("needsMoreCharsMessage", needsMoreCharsMessage);
      vue.provide("fetchingOptions", fetchingOptions);
      vue.provide("fetchingMoreOptions", fetchingMoreOptions);
      vue.provide("dropdownBottomReachedHandler", dropdownBottomReachedHandler);
      vue.provide("usesTags", usesTags);
      return {
        configuration,
        attributes,
        localValue,
        activeOption,
        hasSelectedOption,
        shown,
        dropdownComponent,
        hideDropdown,
        toggleDropdown,
        throttledShowDropdown,
        keydownDownHandler,
        keydownUpHandler,
        keydownSpaceHandler,
        keydownEnterHandler,
        keydownEscHandler,
        focusDropdownTrigger,
        optionIsSelected,
        initActiveOption,
        selectOption,
        selectOptionFromActiveOption,
        clearValue,
        doFetchOptions,
        doPrefetchOptions,
        adjustDropdown,
        fetchOptionsCancel,
        fetchsOptions,
        optionsWereFetched,
        needsMoreCharsToFetch,
        showSearchInput,
        flattenedOptions,
        usesTags,
        searchQuery
      };
    },
    computed: {
      canFetchOptions() {
        return this.fetchsOptions && !this.optionsWereFetched && !this.needsMoreCharsToFetch;
      },
      canPreFetchOptions() {
        if (typeof this.configuration.prefetchOptions === "function") {
          return !this.optionsWereFetched;
        }
        return this.canFetchOptions;
      },
      dropdownClasses() {
        const {
          enterActiveClass,
          enterFromClass,
          enterToClass,
          leaveActiveClass,
          leaveFromClass,
          leaveToClass,
          trigger,
          dropdown
        } = this.configuration.classesList;
        return {
          trigger,
          dropdown,
          enterActiveClass,
          enterFromClass,
          enterToClass,
          leaveActiveClass,
          leaveFromClass,
          leaveToClass
        };
      },
      showClearButton() {
        return this.hasSelectedOption && this.configuration.clearable === true && this.configuration.disabled !== true;
      }
    },
    watch: {
      localValue() {
        this.onOptionSelected();
      }
    },
    created() {
      if (this.configuration.prefetchOptions && this.canPreFetchOptions) {
        this.doPrefetchOptions();
      }
    },
    beforeUnmount() {
      this.fetchOptionsCancel();
    },
    methods: {
      onOptionSelected() {
        this.$emit("input", new CustomEvent("input", {
          detail: this.localValue
        }));
        this.$emit("change", new CustomEvent("change", {
          detail: this.localValue
        }));
        if (this.shown === false) {
          return;
        }
        this.adjustDropdown();
        if (this.configuration.closeOnSelect === true || this.configuration.closeOnSelect === void 0 && !this.configuration.multiple) {
          this.hideDropdown();
          this.focusDropdownTrigger();
        }
      },
      beforeHideHandler() {
        var _a;
        this.$emit("before-hide");
        if (this.configuration.selectOnClose && !core.isEqual(this.localValue, (_a = this.activeOption) == null ? void 0 : _a.value)) {
          this.selectOptionFromActiveOption();
        }
      },
      shownHandler() {
        this.$emit("shown");
        this.shown = true;
      },
      hiddenHandler() {
        this.$emit("hidden");
        this.shown = false;
        if (this.clearSearchOnClose) {
          this.searchQuery = void 0;
        }
      },
      beforeShowHandler() {
        this.$emit("before-show");
        this.initActiveOption();
        if (this.canFetchOptions) {
          this.doFetchOptions();
        }
      },
      mousedownHandler(e) {
        this.$emit("mousedown", e);
        if (this.configuration.toggleOnClick) {
          if (this.showSearchInput && this.shown === false) {
            e.preventDefault();
          }
          this.toggleDropdown();
        }
      },
      focusHandler(e) {
        this.$emit("focus", e);
        if (this.configuration.toggleOnFocus) {
          this.throttledShowDropdown();
        }
      },
      blurOnChildHandler(e) {
        const target = e.target;
        const relatedTarget = e.relatedTarget;
        const relatedTargetDataset = relatedTarget instanceof HTMLElement ? relatedTarget.dataset : void 0;
        if (target.dataset.richSelectFocusable !== void 0 && relatedTargetDataset && relatedTargetDataset.richSelectFocusable === void 0) {
          target.focus();
        }
      },
      blurHandler(e) {
        this.$emit("blur", e);
        this.hideDropdown();
      }
    }
  });
  function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
    var _a;
    const _component_t_select = vue.resolveComponent("t-select");
    const _component_rich_select_trigger = vue.resolveComponent("rich-select-trigger");
    const _component_rich_select_dropdown = vue.resolveComponent("rich-select-dropdown");
    const _component_t_dropdown = vue.resolveComponent("t-dropdown");
    const _component_rich_select_clear_button = vue.resolveComponent("rich-select-clear-button");
    return vue.openBlock(), vue.createElementBlock("div", vue.mergeProps({
      class: (_a = _ctx.configuration.classesList) == null ? void 0 : _a.wrapper
    }, _ctx.attributes), [
      vue.createVNode(_component_t_select, {
        modelValue: _ctx.localValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.localValue = $event),
        name: _ctx.configuration.name,
        style: { "display": "none" },
        "fixed-classes": void 0,
        classes: void 0,
        multiple: _ctx.configuration.multiple,
        options: _ctx.flattenedOptions
      }, null, 8, ["modelValue", "name", "multiple", "options"]),
      vue.createVNode(_component_t_dropdown, {
        ref: "dropdownComponent",
        disabled: _ctx.configuration.disabled,
        classes: _ctx.dropdownClasses,
        "fixed-classes": void 0,
        "toggle-on-focus": false,
        "toggle-on-click": false,
        "toggle-on-hover": false,
        "popper-options": _ctx.configuration.dropdownPopperOptions,
        placement: _ctx.configuration.dropdownPlacement,
        "tag-name": _ctx.usesTags ? "div" : "button",
        tabindex: _ctx.usesTags && !_ctx.hasSelectedOption ? 0 : void 0,
        teleport: _ctx.configuration.teleport,
        "teleport-to": _ctx.configuration.teleportTo,
        "data-rich-select-focusable": "",
        onMouseover: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("mouseover", $event)),
        onMouseleave: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("mouseleave", $event)),
        onTouchstart: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("touchstart", $event)),
        onShown: _ctx.shownHandler,
        onHidden: _ctx.hiddenHandler,
        onBeforeShow: _ctx.beforeShowHandler,
        onBeforeHide: _ctx.beforeHideHandler,
        onBlur: _ctx.blurHandler,
        onFocus: _ctx.focusHandler,
        onKeydown: [
          vue.withKeys(_ctx.keydownEnterHandler, ["enter"]),
          vue.withKeys(_ctx.keydownSpaceHandler, ["space"]),
          vue.withKeys(_ctx.keydownDownHandler, ["down"]),
          vue.withKeys(_ctx.keydownUpHandler, ["up"]),
          vue.withKeys(_ctx.keydownEscHandler, ["esc"])
        ],
        onMousedown: _ctx.mousedownHandler,
        onBlurOnChild: _ctx.blurOnChildHandler
      }, {
        trigger: vue.withCtx(() => [
          vue.createVNode(_component_rich_select_trigger, { ref: "trigger" }, {
            selectorIcon: vue.withCtx((props) => [
              vue.renderSlot(_ctx.$slots, "selectorIcon", vue.normalizeProps(vue.guardReactiveProps(props)))
            ]),
            placeholder: vue.withCtx((props) => [
              vue.renderSlot(_ctx.$slots, "placeholder", vue.normalizeProps(vue.guardReactiveProps(props)))
            ]),
            label: vue.withCtx((props) => [
              vue.renderSlot(_ctx.$slots, "label", vue.normalizeProps(vue.guardReactiveProps(props)))
            ]),
            tagCloseIcon: vue.withCtx((props) => [
              vue.renderSlot(_ctx.$slots, "tagCloseIcon", vue.normalizeProps(vue.guardReactiveProps(props)))
            ]),
            tagLabel: vue.withCtx((props) => [
              vue.renderSlot(_ctx.$slots, "tagLabel", vue.normalizeProps(vue.guardReactiveProps(props)))
            ]),
            _: 3
          }, 512)
        ]),
        default: vue.withCtx(() => [
          vue.createVNode(_component_rich_select_dropdown, { ref: "dropdown" }, {
            option: vue.withCtx((props) => [
              vue.renderSlot(_ctx.$slots, "option", vue.normalizeProps(vue.guardReactiveProps(props)))
            ]),
            optionLabel: vue.withCtx((props) => [
              vue.renderSlot(_ctx.$slots, "optionLabel", vue.normalizeProps(vue.guardReactiveProps(props)))
            ]),
            optionIcon: vue.withCtx((props) => [
              vue.renderSlot(_ctx.$slots, "optionIcon", vue.normalizeProps(vue.guardReactiveProps(props)))
            ]),
            dropdownTop: vue.withCtx((props) => [
              vue.renderSlot(_ctx.$slots, "dropdownTop", vue.normalizeProps(vue.guardReactiveProps(props)))
            ]),
            dropdownButton: vue.withCtx((props) => [
              vue.renderSlot(_ctx.$slots, "dropdownButton", vue.normalizeProps(vue.guardReactiveProps(props)))
            ]),
            stateFeedback: vue.withCtx((props) => [
              vue.renderSlot(_ctx.$slots, "stateFeedback", vue.normalizeProps(vue.guardReactiveProps(props)))
            ]),
            _: 3
          }, 512)
        ]),
        _: 3
      }, 8, ["disabled", "classes", "popper-options", "placement", "tag-name", "tabindex", "teleport", "teleport-to", "onShown", "onHidden", "onBeforeShow", "onBeforeHide", "onBlur", "onFocus", "onKeydown", "onMousedown", "onBlurOnChild"]),
      _ctx.showClearButton ? (vue.openBlock(), vue.createBlock(_component_rich_select_clear_button, {
        key: 0,
        ref: "clearButton",
        onClick: _ctx.clearValue
      }, {
        clearButton: vue.withCtx((props) => [
          vue.renderSlot(_ctx.$slots, "clearButton", vue.mergeProps(props, {
            classesList: _ctx.configuration.classesList
          }))
        ]),
        _: 3
      }, 8, ["onClick"])) : vue.createCommentVNode("", true)
    ], 16);
  }
  var TRichSelect = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2]]);
  const _sfc_main$1 = vue.defineComponent({
    name: "TTag",
    compatConfig: {
      MODE: 3
    },
    props: __spreadProps(__spreadValues({}, getVariantProps()), {
      tagName: {
        type: String,
        default: "div"
      },
      text: {
        type: String,
        default: void 0
      }
    }),
    setup() {
      const { configuration, attributes } = useConfiguration(core.TTagConfig);
      return { configuration, attributes };
    }
  });
  function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
    return vue.openBlock(), vue.createBlock(vue.resolveDynamicComponent(_ctx.configuration.tagName), vue.normalizeProps(vue.guardReactiveProps(_ctx.attributes)), {
      default: vue.withCtx(() => [
        vue.renderSlot(_ctx.$slots, "default", { configuration: _ctx.configuration }, () => [
          vue.createTextVNode(vue.toDisplayString(_ctx.configuration.text), 1)
        ])
      ]),
      _: 3
    }, 16);
  }
  var TTag = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1]]);
  const _sfc_main = vue.defineComponent({
    name: "TToggle",
    compatConfig: {
      MODE: 3
    },
    props: __spreadProps(__spreadValues({}, getVariantPropsWithClassesList()), {
      name: {
        type: String,
        default: void 0
      },
      modelValue: {
        type: [String, Number, Boolean, Array, Object, Date, Function, Symbol],
        default: void 0
      },
      value: {
        type: [String, Number, Boolean, Array, Object, Date, Function, Symbol],
        default: true
      },
      uncheckedValue: {
        type: [String, Number, Boolean, Array, Object, Date, Function, Symbol],
        default: false
      },
      checked: {
        type: Boolean,
        default: void 0
      },
      disabled: {
        type: Boolean,
        default: void 0
      },
      checkedPlaceholder: {
        type: String,
        default: void 0
      },
      uncheckedPlaceholder: {
        type: String,
        default: void 0
      }
    }),
    emits: {
      "update:checked": (isChecked) => true,
      "update:modelValue": (value) => true
    },
    setup(props, { emit }) {
      const { configuration, attributes } = useConfigurationWithClassesList(core.TToggleConfig, core.TToggleClassesKeys);
      const vm = vue.getCurrentInstance();
      const getInitialValue = () => {
        const modelValueIsDefined = core.hasProperty(vm.vnode.props, "modelValue");
        if (modelValueIsDefined) {
          return props.modelValue;
        }
        if (configuration.checked === true) {
          return configuration.value;
        }
        return configuration.uncheckedValue;
      };
      const localValue = vue.ref(getInitialValue());
      const isMultiple = vue.computed(() => Array.isArray(localValue.value));
      const isChecked = vue.computed(() => {
        if (isMultiple.value) {
          return localValue.value.some((value) => core.isEqual(value, configuration.value));
        }
        return core.isEqual(localValue.value, configuration.value);
      });
      const inputValue = vue.computed(() => {
        if (isChecked.value) {
          return configuration.value;
        }
        return configuration.uncheckedValue;
      });
      const check = () => {
        if (isMultiple.value) {
          localValue.value = core.addToArray(localValue.value, configuration.value);
        } else {
          localValue.value = configuration.value;
        }
      };
      const uncheck = () => {
        if (isMultiple.value) {
          localValue.value = core.substractFromArray(localValue.value, configuration.value);
        } else {
          localValue.value = configuration.uncheckedValue;
        }
      };
      const toggle = () => {
        if (isChecked.value) {
          uncheck();
        } else {
          check();
        }
      };
      vue.watch(localValue, (newValue) => {
        emit("update:modelValue", newValue);
      });
      vue.watch(isChecked, (newIsChecked) => {
        emit("update:checked", newIsChecked);
      });
      vue.watch(() => props.modelValue, (newModelValue) => {
        localValue.value = newModelValue;
      });
      vue.watch(() => configuration.checked, (newChecked) => {
        if (newChecked) {
          check();
        } else {
          uncheck();
        }
      });
      const classes = vue.computed(() => {
        if (configuration.disabled) {
          return {
            wrapper: isChecked.value ? configuration.classesList.wrapperCheckedDisabled : configuration.classesList.wrapperDisabled,
            button: isChecked.value ? configuration.classesList.buttonChecked : configuration.classesList.button
          };
        }
        return {
          wrapper: isChecked.value ? configuration.classesList.wrapperChecked : configuration.classesList.wrapper,
          button: isChecked.value ? configuration.classesList.buttonChecked : configuration.classesList.button
        };
      });
      return {
        configuration,
        attributes,
        localValue,
        isChecked,
        isMultiple,
        classes,
        inputValue,
        toggle
      };
    }
  });
  const _hoisted_1 = ["aria-checked", "disabled"];
  const _hoisted_2 = ["value", "name", "disabled"];
  function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b;
    return vue.openBlock(), vue.createElementBlock("button", {
      type: "button",
      role: "checkbox",
      "aria-checked": _ctx.isChecked ? "true" : "false",
      class: vue.normalizeClass(_ctx.classes.wrapper),
      disabled: _ctx.configuration.disabled,
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.toggle && _ctx.toggle(...args))
    }, [
      !_ctx.isMultiple || _ctx.isChecked ? (vue.openBlock(), vue.createElementBlock("input", {
        key: 0,
        value: _ctx.inputValue,
        type: "hidden",
        name: _ctx.configuration.name,
        disabled: _ctx.configuration.disabled
      }, null, 8, _hoisted_2)) : vue.createCommentVNode("", true),
      vue.createElementVNode("span", {
        "aria-hidden": "true",
        class: vue.normalizeClass((_a = _ctx.configuration.classesList) == null ? void 0 : _a.uncheckedPlaceholder)
      }, [
        vue.renderSlot(_ctx.$slots, "unchecked", {
          value: _ctx.inputValue,
          isChecked: _ctx.isChecked
        }, () => [
          vue.createTextVNode(vue.toDisplayString(_ctx.configuration.uncheckedPlaceholder), 1)
        ])
      ], 2),
      vue.createElementVNode("span", {
        "aria-hidden": "true",
        class: vue.normalizeClass((_b = _ctx.configuration.classesList) == null ? void 0 : _b.checkedPlaceholder)
      }, [
        vue.renderSlot(_ctx.$slots, "checked", {
          value: _ctx.inputValue,
          isChecked: _ctx.isChecked
        }, () => [
          vue.createTextVNode(vue.toDisplayString(_ctx.configuration.checkedPlaceholder), 1)
        ])
      ], 2),
      vue.createElementVNode("span", {
        "aria-hidden": "true",
        class: vue.normalizeClass(_ctx.classes.button)
      }, [
        vue.renderSlot(_ctx.$slots, "default", {
          value: _ctx.inputValue,
          isChecked: _ctx.isChecked
        })
      ], 2)
    ], 10, _hoisted_1);
  }
  var TToggle = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
  exports2.Emitter = Emitter;
  exports2.LoadingIcon = LoadingIcon;
  exports2.TAlert = TAlert;
  exports2.TButton = TButton;
  exports2.TCard = TCard;
  exports2.TCheckbox = TCheckbox;
  exports2.TDialog = TDialog;
  exports2.TDropdown = TDropdown;
  exports2.TInput = TInput;
  exports2.TInputGroup = TInputGroup;
  exports2.TModal = TModal;
  exports2.TRadio = TRadio;
  exports2.TRichSelect = TRichSelect;
  exports2.TSelect = TSelect;
  exports2.TTag = TTag;
  exports2.TTextarea = TTextarea;
  exports2.TToggle = TToggle;
  exports2.getVariantProps = getVariantProps;
  exports2.getVariantPropsWithClassesList = getVariantPropsWithClassesList;
  exports2.sameWidthModifier = sameWidthModifier;
  exports2.svgToVueComponent = svgToVueComponent;
  exports2.useActivableOption = useActivableOption;
  exports2.useConfiguration = useConfiguration;
  exports2.useConfigurationWithClassesList = useConfigurationWithClassesList;
  exports2.useFetchsOptions = useFetchsOptions;
  exports2.useInjectsClassesList = useInjectsClassesList;
  exports2.useInjectsClassesListClass = useInjectsClassesListClass;
  exports2.useInjectsConfiguration = useInjectsConfiguration;
  exports2.useMulipleableVModel = useMulipleableVModel;
  exports2.useMultioptions = useMultioptions;
  exports2.useSelectableOption = useSelectableOption;
  exports2.useVModel = useVModel;
  exports2.variantJS = plugin;
  Object.defineProperty(exports2, "__esModule", { value: true });
  exports2[Symbol.toStringTag] = "Module";
});
//# sourceMappingURL=index.umd.js.map
